/* r16 (2026-07-31) - Mariya: "structure is still jumping down the page ...
   It jumps to 'dowel board and calculator'."
   MUST RUN FIRST. This lived at the END of the file and did nothing,
   because the tab-mode init further up writes '#dowels' into the URL with
   replaceState during load - so by the time this ran, its "no hash in the
   URL" guard saw a hash and bailed. Batch Math's copy only worked because
   it happened to sit above its tab init. Reading the hash before anything
   can rewrite it is the whole point.
   Still a symptom fix: it asserts the top rather than curing whatever
   moves the viewport. A real deep link (#dowels typed or followed) is
   honoured, and any touch from the reader stops it immediately. */
(function lstrLandAtTop() {
  var startedWithHash = !!(location.hash && location.hash.length > 1);
  if (startedWithHash) return;
  var userMoved = false;
  function mark() { userMoved = true; }
  window.addEventListener('wheel', mark, { passive: true });
  window.addEventListener('touchstart', mark, { passive: true });
  window.addEventListener('keydown', mark);
  /* A TIMER, not requestAnimationFrame: rAF does not tick while the tab is
     hidden or backgrounded, so an rAF version silently never ran (which is
     exactly how it fooled me in testing). setTimeout keeps working. */
  var t0 = Date.now();
  var iv = setInterval(function () {
    if (userMoved || Date.now() - t0 > 1500) { clearInterval(iv); return; }
    if (window.pageYOffset !== 0) { try { window.scrollTo(0, 0); } catch (e) { } }
  }, 50);
})();

/* ============================================================
   STRUCTURE — Support & Transport Calculators (FREE bundle)
   LAYER'D Cakes · Brief 02 + Access Gating retrofit

   ┌─────────────────────────────────────────────────────────┐
   │  MARIYA: the numbers no longer live in this file. They  │
   │  live in structure/structure-rules.json — edit there,   │
   │  double-click generate.bat, re-paste the dist template. │
   └─────────────────────────────────────────────────────────┘

   This is the FREE bundle: full structural guidance for one-
   and two-tier standard cakes, plus the whole transport check.
   It reads its numbers from the #lstr-config data island.

   3+ tiers, tall/double-barrel and dense-load engineering live
   in the premium bundle + #lstr-premium island, which Shopify
   renders ONLY for premium customers (learn-hub-pro OR academy-member tag) (server-side).
   This file must never contain those rules, in any form.

   If the premium bundle registered itself (member page), this
   file upgrades automatically:
     window.LAYERD.premium.structure = { maxTiers, presets,
                                         rules, copy, materialFor }
   ============================================================ */

(function () {
  'use strict';
  /* r78 (Mariya's recording, frames 117-122): tapping this tab from another
     page arrived SCROLLED to the last visit's position - the sticky slider
     bar pinned at the very top, header off-screen - then snapped to the top
     a beat later as the JS-built content mounted. That lurch was "the
     glitch" on exactly the sliding-bar pages. Same cure the Planner got for
     the same disease: own the scroll, arrive at the top. Deep links
     (#batter, #ganache...) keep their sanctioned landing. */
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (eSR) { }
  if (!location.hash) {
    try { window.scrollTo(0, 0); } catch (eST) { }
    setTimeout(function () { try { if (!location.hash) window.scrollTo(0, 0); } catch (e) { } }, 0);
  }


  /* ---------- config island (free numbers) ---------- */

  var CFG = null;
  try {
    var cfgEl = document.getElementById('lstr-config');
    CFG = cfgEl ? JSON.parse(cfgEl.textContent) : null;
  } catch (e) { CFG = null; }

  function premium() {
    return (window.LAYERD && window.LAYERD.premium && window.LAYERD.premium.structure) || null;
  }

  function maxTiers() {
    var P = premium();
    return P ? P.maxTiers : ((CFG && CFG.maxTiers) || 2);
  }

  function presetFor(n) {
    var P = premium();
    var key = String(n);
    if (CFG.presets && CFG.presets[key]) return CFG.presets[key];
    if (P && P.presets && P.presets[key]) return P.presets[key];
    return CFG.presets['2'];
  }

  /* ---------- shared helpers ---------- */

  var SUPPORT_LABEL = {
    straws:  { one: 'bubble tea straw',          many: 'bubble tea straws' },
    plastic: { one: 'heavy-duty plastic dowel',  many: 'heavy-duty plastic dowels' },
    wooden:  { one: '¼″ wooden dowel',           many: '¼″ wooden dowels' }
  };

  /* Premium materials arrive by name through the member island only —
     this file knows nothing about them beyond "look the label up". */
  function matLabel(m) {
    var P = premium();
    if (P && P.labels && P.labels[m]) return P.labels[m];
    return SUPPORT_LABEL[m] || SUPPORT_LABEL.wooden;
  }

  var LOCK_SVG = '<svg class="lstr-lock" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6V5a4 4 0 1 1 8 0v1h1.25c.41 0 .75.34.75.75v7.5c0 .41-.34.75-.75.75H2.75a.75.75 0 0 1-.75-.75v-7.5c0-.41.34-.75.75-.75H4Zm2 0h4V5a2 2 0 1 0-4 0v1Z"/></svg>';

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /* ---------- units: inches ↔ cm, shared suite-wide ----------
     Same contract as Batch Math: ONE preference for every Learn tool
     (same localStorage key). Internal math NEVER changes, tiers are
     stored, computed and shared (layerd-learn-tiers) in inches; cm is
     a LABEL, mapped to the standard retail metric pan sizes
     (6″ ↔ 15 cm, 8″ ↔ 20 cm…), so dowel counts, board rules and
     Mariya's verified numbers stay put. Every pan/board size funnels
     through inch(); ledge, inset and margin measurements are craft
     rules rather than pan sizes and stay in inches. */
  var UNITS_KEY = 'layerd-learn-units';
  var IN2CM = { 4: 10, 5: 13, 6: 15, 7: 18, 8: 20, 9: 23, 10: 25, 11: 28, 12: 30, 13: 33, 14: 35, 15: 38, 16: 40 };
  function unitPref() {
    try { return localStorage.getItem(UNITS_KEY) === 'cm' ? 'cm' : 'in'; } catch (e) { return 'in'; }
  }
  function inch(n) { return unitPref() === 'cm' ? (IN2CM[n] || Math.round(n * 2.54)) + ' cm' : n + '″'; } // 8″ / 20 cm
  var unitListeners = [];   // rebuilds registered at boot, fired on toggle

  function unitToggle() {
    var box = document.createElement('span');
    box.className = 'lrn-units';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Pan size units');
    [['in', 'inches'], ['cm', 'cm']].forEach(function (u) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lrn-units__btn' + (unitPref() === u[0] ? ' is-active' : '');
      b.textContent = u[1];
      b.addEventListener('click', function () {
        try { localStorage.setItem(UNITS_KEY, u[0]); } catch (e) { /* private mode */ }
        Array.prototype.forEach.call(box.children, function (c) { c.classList.remove('is-active'); });
        b.classList.add('is-active');
        unitListeners.forEach(function (fn) { fn(); });
      });
      box.appendChild(b);
    });
    var wrap = document.createElement('div');
    wrap.className = 'lstr-units';
    wrap.appendChild(box);
    return wrap;
  }
  /* temperatures are set in °C; always show the °F twin alongside */
  function degF(c) { return Math.round(c * 9 / 5 + 32); }
  function tempTxt(c) { return c + ' °C · ' + degF(c) + ' °F'; }
  function clamp(n, lo, hi) { return Math.min(hi, Math.max(lo, n)); }

  /* ---------- state ---------- */

  var state = {
    tiers: [],
    covering: 'buttercream',
    florals: false
  };

  var tstate = {
    minutes: 30,
    temp: 20,
    ac: true,
    covering: 'buttercream',
    stacked: true,
    road: 'city'
  };

  var sharedNotice = '';

  /* Shared with Batch Math (Brief 03): one cake's tier set carries across
     both tools in the same browser tab. Format:
     {"tiers":[{"d":8,"h":5,"shape":"round"}, …]}
     Convenience only, NEVER an access decision. */
  var SHARED_TIERS_KEY = 'layerd-learn-tiers';

  /* ---- client-file hardware save (Client File & Quote Engine §2.2/§5.3) ----
     Arriving from a file (the Planner tracker's "Structure —" segment opens
     /pages/structure?booking=<id>), the computed dowel/board list saves back
     onto that file as its hardwareList, which the Planner then merges into the
     shopping roll-up on confirmation. Same handoff pattern as Pricing's quote
     save; bookings are the baker's own free-tier localStorage, so no gating. */
  var BOOKINGS_KEY = 'layerd-academy-bookings';
  var CAKE_HEX = ['#4C3A50', '#6F7D62', '#BCA069', '#7A4A55'];   /* slot 0 stays aubergine, not the brand ink (see learn-tokens --cake-1) */
  var structureBooking = (function () {
    /* Toolkit Fix 01: scope resolves through the shared cake-file layer —
       ?booking= wins and sets the global pointer; a plain visit keeps the
       client picked anywhere in the suite. */
    if (window.LdCakeFile) return window.LdCakeFile.resolveScope();
    var m = location.search.match(/[?&]booking=([^&]+)/);
    if (!m) return null;
    var id; try { id = decodeURIComponent(m[1]); } catch (e) { id = m[1]; }
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || (v.v !== 1 && v.v !== 2) || !v.bookings) return null;
      for (var i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === id) return v.bookings[i];
    } catch (e) { /* private mode / corrupt */ }
    return null;
  })();
  function hwPlannerUrl() {
    var a = document.querySelector('.learn-subnav__tab--flagship');
    return (a && a.getAttribute('href')) || '/pages/planner';
  }
  function hwTodayISO() {
    var d = new Date();
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }
  function hwGaTier() {
    var host = document.querySelector('[data-lh-tier]');
    var t = host && host.getAttribute('data-lh-tier');
    return (t === 'free' || t === 'premium' || t === 'visitor') ? t : 'visitor';
  }
  function hwGa(type) {
    try { if (window.lhTrack) window.lhTrack('learn_hub_cta_clicked', { tool_name: 'structure', cta_type: type, user_tier: hwGaTier() }); } catch (e) { }
  }
  function saveHardwareToBooking() {
    if (!structureBooking) return null;
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || (v.v !== 1 && v.v !== 2) || !v.bookings) return null;
      var bk = null;
      for (var i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === structureBooking.id) { bk = v.bookings[i]; break; }
      if (!bk) return null;
      bk.hardwareList = { lines: shoppingList(), tierCount: state.tiers.length, at: hwTodayISO() };
      /* gating brief §5: saving the reviewed plan IS the structure
         approval, a later size change resets this to false */
      bk.structureConfirmed = true;
      localStorage.setItem(BOOKINGS_KEY, JSON.stringify(v));
      try { window.dispatchEvent(new CustomEvent('layerd:cakefile', { detail: { type: 'file', source: 'structure' } })); } catch (e) { }
      return { ok: true };
    } catch (e) { return null; }
  }

  /* Tier heights from the config island: standard = 4" (Wilton-aligned,
     drives the h handed to Batch Math), tall starts at tallFromIn. The
     chip label reads "5" or less" so 5" bakers know they're standard —
     structurally everything under tallFromIn behaves the same. */
  function stdH() { return (CFG && CFG.rules.standardTierIn) || 4; }
  function tallH() { return (CFG && CFG.rules.tallFromIn) || 6; }

  /* CONTRACT v2 (2026-07-09): stamped { tiers, at, from } lives in BOTH
     localStorage (cross-tab) and sessionStorage (legacy); adopt the
     NEWEST stamp so the latest edit anywhere in the suite wins. */
  function readSharedRaw() {
    var best = null;
    [localStorage, sessionStorage].forEach(function (store) {
      try {
        var v = JSON.parse(store.getItem(SHARED_TIERS_KEY));
        if (v && Array.isArray(v.tiers) && v.tiers.length &&
            (!best || (v.at || 1) > (best.at || 1))) best = v;
      } catch (e) { /* private mode / corrupt */ }
    });
    return best;
  }

  /* map any incoming {d,h,shape} rows into Structure's tier objects, applying
     the free-tier cap + tall-flatten (and the "arrived from another tool"
     notice). Shared by the shared-cake path and the booking-tierSpec path. */
  function mapIncomingTiers(rawTiers) {
    var max = maxTiers();
    /* The contract stores tiers BASE FIRST, but be defensive: sort
       largest-first so a writer that saved them upside down can't invert. */
    var all = rawTiers.slice().sort(function (a, b) { return (b.d || 0) - (a.d || 0); });
    var flattened = false;
    var tiers = all.slice(0, max).map(function (t) {
      var tall = (t.h || stdH()) >= tallH();
      if (tall && !premium()) { tall = false; flattened = true; }
      return {
        d: clamp(Math.round(t.d) || 8, 4, 16),
        tall: tall,
        shape: t.shape === 'square' ? 'square' : t.shape === 'heart' ? 'heart' : 'round',
        cake: 'standard',
        /* r43: a dummy is rigid foam — it neither compresses nor weighs
           anything worth supporting, so it changes what has to be dowelled
           both above and below it. See dowelsFor(). */
        faux: !!t.faux
      };
    });
    if (!premium() && (all.length > max || flattened)) {
      sharedNotice = 'This cake arrived from another Toolkit tool with ' +
        (all.length > max ? all.length + ' tiers' : 'a tall tier') +
        /* r184 (2026-08-29, Mariya: "can we just make this a hyperlink
           instead of leading them to the bottom of the page?"). Sending
           someone to scroll for the offer was asking them to do the work of
           a link. Straight to the product page now. */
        ', the free calculator covers one and two standard tiers. ' +
        'The rest lives in <a class="lstr-pro-link" href="/products/learn-hub-pro">LAYER’D Toolkit Pro</a>.';
    }
    return tiers;
  }

  function loadSharedTiers() {
    try {
      var data = readSharedRaw();
      if (!data || !Array.isArray(data.tiers)) return null;
      var tiers = mapIncomingTiers(data.tiers);
      return tiers.length >= 2 ? tiers : null;
    } catch (e) { return null; }
  }

  /* a client's SAVED tiers (from the Planner's tierSpec) — the source of
     truth when a tool is scoped to a client and the shared cake doesn't
     belong to that client (2026-07-15 fix). Sizes derive EXACTLY like the
     Planner's tierSpecOf: explicit spec entries win, missing ones pad from
     the same presets — so this tool always shows the sizes the Planner
     shows. Bookings are round; height from the booking's `tall` flag. */
  var BOOKING_TIER_PRESETS = { 1: [8], 2: [8, 6], 3: [10, 8, 6], 4: [12, 10, 8, 6], 5: [12, 10, 8, 6, 4], 6: [14, 12, 10, 8, 6, 4] };
  function tiersFromBooking(b) {
    try {
      var spec = Array.isArray(b.tierSpec) ? b.tierSpec : [];
      var n = Math.max(1, +b.tiers || spec.length || 2);
      var preset = BOOKING_TIER_PRESETS[n] || BOOKING_TIER_PRESETS[6];
      var h = b.tall ? tallH() : stdH();
      var raw = [];
      for (var i = 0; i < n; i++) { var s = spec[i] || {}; raw.push({ d: +s.d || preset[i] || 6, h: h, shape: 'round', faux: !!s.faux }); }
      var tiers = mapIncomingTiers(raw);
      return tiers.length ? tiers : null;
    } catch (e) { return null; }
  }

  /* ---- the shared Cake Chip (§3.1): the tool DRIVES the chip from its
     own live tiers, so the chip can never disagree with what Structure is
     computing. adoptedFrom is captured at load, BEFORE the first
     renderDowelResults() re-stamps the shared cake as from:'structure'. */
  var adoptedFrom = null;
  var CHIP_ORIGINS = { serving: 'Serving', 'batch-math': 'Batch Math', pricing: 'Pricing', planner: 'the Planner', timeline: 'the Planner', structure: 'Structure' };
  function chipSummary() {
    var ts = state.tiers.slice().sort(function (a, b) { return (b.d || 0) - (a.d || 0); });
    var sizes = ts.map(function (t) { return inch(t.d); }).join(' + ');
    var shapes = {};
    ts.forEach(function (t) { shapes[t.shape === 'square' ? 'square' : t.shape === 'heart' ? 'heart' : 'round'] = 1; });
    var keys = Object.keys(shapes);
    return sizes + ' · ' + (keys.length === 1 ? keys[0] : 'mixed shapes');
  }
  function updateCakeChip() {
    var mount = document.getElementById('lstr-cakechip');
    if (!mount) return;
    /* scoped to a client file → show the client (name · date · status) with
       the tier summary beneath, via the shared Client Chip (§4.5) */
    var comp = window.LAYERD && window.LAYERD.components;
    if (structureBooking && comp && comp.setClientChip) {
      mount.setAttribute('data-ld-target', '#lstr-clientpick');
      comp.setClientChip(mount, structureBooking, chipSummary());
      return;
    }
    mount.setAttribute('data-ld-summary', chipSummary());
    mount.setAttribute('data-ld-origin',
      !adoptedFrom ? 'Structure’s starting tiers'
        : adoptedFrom === 'structure' ? 'your saved cake'
        : 'from ' + (CHIP_ORIGINS[adoptedFrom] || adoptedFrom));
    if (window.LAYERD && window.LAYERD.components && window.LAYERD.components.refreshCakeChips) {
      window.LAYERD.components.refreshCakeChips();
    }
  }

  function saveSharedTiers() {
    /* Toolkit Fix 01: the scratch slot belongs to ANONYMOUS work only. When
       a client file is active, the booking record is the source of truth —
       scoped tier exploration here never broadcasts anywhere; the file
       changes only via the explicit hardware/stack saves. */
    if (structureBooking) return;
    var payload = JSON.stringify({
      tiers: state.tiers.map(function (t) {
        return { d: t.d, h: t.tall ? tallH() : stdH(), shape: t.shape };
      }),
      at: Date.now(), from: 'structure', bookingId: null
    });
    try { localStorage.setItem(SHARED_TIERS_KEY, payload); } catch (e) { }
    try { sessionStorage.setItem(SHARED_TIERS_KEY, payload); } catch (e) { /* private browsing */ }
  }

  /* Scoped tier edits (Mariya, 2026-07-17): changing sizes here used to go
     nowhere — the file kept Serving's tiers and every other tool stuck to
     them. Now an explicit "update the file" offer appears whenever the
     working stack differs from the client file. Height is bucket-compared
     (standard/tall) because this tool flattens heights; on save, a tier
     whose size+bucket match keeps the file's true height (no 8″ → 6″
     flattening — the Fix 02 lesson). */
  function bucketOf(h) { return (h || stdH()) >= tallH() ? 'T' : 'S'; }
  function shapeOf(t) { return t.shape === 'square' ? 'square' : t.shape === 'heart' ? 'heart' : 'round'; }
  function fileTiersFor() {
    var F = window.LdCakeFile;
    if (!F || !structureBooking) return null;
    var rc = F.readCake();
    if (!rc || !rc.booking || rc.booking.id !== structureBooking.id) return null;
    return rc.tiers;
  }
  function orderedStateTiers() {
    return state.tiers.slice().sort(function (a, b) { return (b.d || 0) - (a.d || 0); });
  }
  function tiersDifferFromFile() {
    var ft = fileTiersFor();
    if (!ft) return false;
    var a = ft.map(function (t) { return t.d + bucketOf(t.h) + (t.shape || 'round'); }).join('|');
    var b = orderedStateTiers().map(function (t) { return t.d + (t.tall ? 'T' : 'S') + shapeOf(t); }).join('|');
    return a !== b;
  }
  function writeTiersToFile() {
    var F = window.LdCakeFile;
    if (!F || !structureBooking) return null;
    var ft = fileTiersFor() || [];
    var payload = orderedStateTiers().map(function (t, i) {
      var h = t.tall ? tallH() : stdH();
      var f = ft[i];
      if (f && f.d === t.d && bucketOf(f.h) === (t.tall ? 'T' : 'S')) h = f.h;
      return { d: t.d, h: h, shape: shapeOf(t) };
    });
    var res = F.writeCake(payload, 'structure');
    if (res) structureBooking = F.getActiveBooking() || structureBooking;
    return res;
  }

  /* ==========================================================
     TOOL 1 — dowel & board calculator
     ========================================================== */

  /* Dowels for the supporting tier at index i (bottom-first).
     Returns null for the top tier (nothing stacks on it).
     Count = the diameter of the tier directly above (Mariya's method);
     the pattern is one even ring inside that tier's footprint. */
  /* r43 (Mariya, 2026-08-06) — faux tiers change WHO carries load.
     Her three cases collapse to one rule: a tier needs dowels iff it is
     REAL and there is at least one REAL tier somewhere above it.
       · faux base            → no dowels in the dummy; everything above
                                dowels as if the tier above it were the base
       · real → faux → real   → the real base still dowels, because real
                                weight ends up over it
       · real → faux on top   → nothing to dowel for; a dummy is too light
                                to need support under it
     The COUNT still keys off the tier DIRECTLY above, faux or not — that is
     geometry, not weight: the dowels have to land inside the footprint of
     whatever actually sits on them. */
  /* SPINE r232: the dowel/board math now lives in the shared engine
     window.LAYERD.structureCore (loaded before this file). These stay as
     the page's call-site names but delegate to the one owner — same inputs
     (state.tiers, CFG.rules, premium()), same outputs, so every render and
     the shopping list are byte-identical. */
  var SC = window.LAYERD && window.LAYERD.structureCore;
  function realAbove(tiers, i) { return SC.realAbove(tiers, i); }
  /* why a tier gets no dowels — "no tier above" was the only reason before
     faux tiers existed, and it is a lie for the other two. She has to be
     able to read the card and agree with it, or she'll dowel it anyway. */
  function noDowelReason(i) { return SC.noDowelReason(state.tiers, i); }
  function roleLabel(i) { return SC.roleLabel(state.tiers, i); }
  function dowelsFor(i) { return SC.dowelsFor(state.tiers, i, CFG.rules, premium()); }

  /* Free rule covers the two-tier, standard-height case only.
     The full escalation tree (bigger stacks, tall loads, chiffon
     exceptions) lives in the premium bundle. */
  function materialFor(i) { return SC.materialFor(state.tiers, i, CFG.rules, premium()); }
  function boardSpec() { return SC.boardSpec(state.tiers, CFG.rules, premium()); }
  function stackWarnings() { return SC.stackWarnings(state.tiers, CFG.rules, premium(), inch); }

  /* ---------- SVG placement diagram ---------- */

  /* One colour per supporting tier — outline, label, tint AND dowels all
     match, so each ring of dots reads back to its tier at a glance.
     Design-system colours only; gold stays reserved for the board edge,
     dimension line and central dowel. */
  /* 2026-09-11 (Mariya): ink-alpha steps, the way the Studio draws the cake -
     tiers read as one monochrome ink family (base darkest, lighter going up),
     not the old five-hue rainbow. Kept as hex because tint() mixes them. */
  var TIER_COLORS = ['#2A2138', '#4A4458', '#6A6478', '#8A8598', '#3E374E'];
  var TOP_TIER_COLOR = '#B6B1C0'; // no dowels to place — deliberately quiet

  function tierColor(i, tiers) {
    if (i >= tiers.length - 1) return TOP_TIER_COLOR;
    return TIER_COLORS[i % TIER_COLORS.length];
  }

  /* flat tint pre-mixed against white — opaque, so nested tiers never
     muddy each other's colour the way stacked transparent fills did */
  function tint(hex, a) {
    var n = parseInt(hex.slice(1), 16);
    function mix(c) { return Math.round(255 * (1 - a) + c * a); }
    return 'rgb(' + mix(n >> 16) + ',' + mix((n >> 8) & 255) + ',' + mix(n & 255) + ')';
  }

  /* 6b — the TOP tier's card: no dowel plan to draw (nothing stacks on
     it), so it's the tier on the same 220 canvas as its siblings — same
     tint, same stroke, the gold centre crosshair where the central dowel
     lands, and the tier label. Uniform with buildTierDiagram, minus the
     footprint it doesn't have. */
  function buildTierMini(i) {
    var tiers = state.tiers;
    var t = tiers[i];
    var col = tierColor(i, tiers);
    var W = 220, PAD = 22;
    var scale = (W - PAD * 2) / t.d;
    var cx = W / 2, cy = W / 2;
    var halo = ';paint-order:stroke;stroke:#FFFFFF;stroke-width:3px;stroke-linejoin:round';
    var s = '<svg viewBox="0 0 ' + W + ' ' + W + '" xmlns="http://www.w3.org/2000/svg" role="img" ' +
            'aria-label="Top tier, centre dowel only">';
    s += shapeEl(t.shape, cx, cy, t.d / 2 * scale, 'fill="' + tint(col, 0.12) + '" stroke="' + col + '" stroke-width="1.5"');
    /* the central dowel's crosshair, same mark as the other diagrams */
    var cr = 8;
    s += '<circle cx="' + cx + '" cy="' + cy + '" r="' + cr + '" fill="none" stroke="#BCA069" stroke-width="1.5"/>';
    s += '<line x1="' + (cx - cr - 3) + '" y1="' + cy + '" x2="' + (cx + cr + 3) + '" y2="' + cy + '" stroke="#BCA069" stroke-width="1.5"/>';
    s += '<line x1="' + cx + '" y1="' + (cy - cr - 3) + '" x2="' + cx + '" y2="' + (cy + cr + 3) + '" stroke="#BCA069" stroke-width="1.5"/>';
    s += '<text class="lstr-svg-label" style="fill:' + col + halo + '" x="' + cx + '" y="' + (cy - t.d / 2 * scale + 15) + '" text-anchor="middle">' + inch(t.d) + ' tier</text>';
    return s + '</svg>';
  }

  /* One tier on its own card: the supporting tier, the traced footprint
     of the tier above (the line you actually mark on the cake), and
     exactly the dowels that go into this tier — nothing else. */
  function buildTierDiagram(i) {
    var tiers = state.tiers;
    var t = tiers[i];
    var p = dowelsFor(i);
    var col = tierColor(i, tiers);
    var W = 220, PAD = 22;
    /* scale to the widest element — an oversized footprint (inverted
       stack) must stay inside the canvas, same rule as the stack view */
    var scale = (W - PAD * 2) / Math.max(t.d, p.above.d);
    var cx = W / 2, cy = W / 2;
    var halo = ';paint-order:stroke;stroke:#FFFFFF;stroke-width:3px;stroke-linejoin:round';

    var s = '<svg viewBox="0 0 ' + W + ' ' + W + '" xmlns="http://www.w3.org/2000/svg" role="img" ' +
            'aria-label="Dowel placement for tier ' + (i + 1) + '">';
    s += shapeEl(t.shape, cx, cy, t.d / 2 * scale,
      'fill="' + tint(col, 0.12) + '" stroke="' + col + '" stroke-width="1.5"');
    /* the footprint you trace from the board above */
    s += shapeEl(p.patternShape, cx, cy, p.above.d / 2 * scale,
      'fill="none" stroke="' + col + '" stroke-width="1.25" stroke-dasharray="5 4"');

    var dotR = clamp(scale * 0.28, 4, 6.5);
    positionsFor(p, t, scale).forEach(function (q) {
      s += '<circle cx="' + (cx + q[0]).toFixed(1) + '" cy="' + (cy + q[1]).toFixed(1) + '" r="' + dotR + '" fill="' + col + '"/>';
    });
    if (p.inner) {
      innerPositionsFor(p, t, scale).forEach(function (q) {
        s += '<circle cx="' + (cx + q[0]).toFixed(1) + '" cy="' + (cy + q[1]).toFixed(1) + '" r="' + (dotR * 0.8).toFixed(1) + '" fill="#FFFFFF" stroke="' + col + '" stroke-width="2"/>';
      });
    }
    /* centre stays clear — the central dowel takes it after stacking */
    var cr = dotR + 2;
    s += '<circle cx="' + cx + '" cy="' + cy + '" r="' + cr + '" fill="none" stroke="#BCA069" stroke-width="1.5"/>';
    s += '<line x1="' + (cx - cr - 3) + '" y1="' + cy + '" x2="' + (cx + cr + 3) + '" y2="' + cy + '" stroke="#BCA069" stroke-width="1.5"/>';
    s += '<line x1="' + cx + '" y1="' + (cy - cr - 3) + '" x2="' + cx + '" y2="' + (cy + cr + 3) + '" stroke="#BCA069" stroke-width="1.5"/>';

    s += '<text class="lstr-svg-label" style="fill:' + col + halo + '" x="' + cx + '" y="' + (cy - t.d / 2 * scale + 15) + '" text-anchor="middle">' + inch(t.d) + ' tier</text>';
    s += '<text class="lstr-svg-dim" style="fill:' + col + halo + '" x="' + cx + '" y="' + (cy - p.above.d / 2 * scale + 14) + '" text-anchor="middle">' + inch(p.above.d) + ' FOOTPRINT</text>';
    return s + '</svg>';
  }

  /* buildDiagram (the full-stack top-down) REMOVED 2026-07-15 — redundant
     with the side elevation (Mariya). The per-tier diagrams carry the
     placement detail now. */

  function shapeEl(shape, cx, cy, r, attrs) {
    if (shape === 'square') {
      return '<rect x="' + (cx - r).toFixed(1) + '" y="' + (cy - r).toFixed(1) + '" width="' + (r * 2).toFixed(1) +
             '" height="' + (r * 2).toFixed(1) + '" rx="3" ' + attrs + '/>';
    }
    return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r.toFixed(1) + '" ' + attrs + '/>';
  }

  /* px offsets from centre for each dowel in a supporting tier —
     one even ring (no centre dowel in the pattern; the central
     sharpened dowel takes the centre on every stacked cake) */
  function positionsFor(plan, supporting, scale) {
    var pts = [];
    var insetIn = CFG.rules.ringInsetIn;
    var limitIn = supporting.d / 2 - 0.5; // never poke outside the tier the dowels live in
    var n = plan.count;

    if (plan.patternShape === 'square') {
      var half = Math.max(0.5, Math.min(plan.above.d / 2 - insetIn, limitIn)) * scale;
      var order = [[-1, -1], [1, -1], [1, 1], [-1, 1]]; // corners first
      var mids = [[0, -1], [1, 0], [0, 1], [-1, 0]];
      for (var i = 0; i < Math.min(n, 4); i++) pts.push([order[i][0] * half, order[i][1] * half]);
      for (var j = 0; j < n - 4 && j < 4; j++) pts.push([mids[j][0] * half, mids[j][1] * half]);
      /* anything past 8 sits on an inner ring, clear of the centre */
      var extra = n - 8;
      for (var k = 0; k < extra; k++) {
        var a = -Math.PI / 2 + (Math.PI * 2 / extra) * k + Math.PI / extra;
        pts.push([Math.cos(a) * half * 0.5, Math.sin(a) * half * 0.5]);
      }
      return pts;
    }

    var rIn = Math.max(0.5, Math.min(plan.above.d / 2 - insetIn, limitIn));
    var r = rIn * scale;
    var step = (Math.PI * 2) / n;
    var start = -Math.PI / 2 + step / 2; // keep top-centre clear for the size label
    for (var m = 0; m < n; m++) {
      pts.push([Math.cos(start + m * step) * r, Math.sin(start + m * step) * r]);
    }
    return pts;
  }

  /* second ring at a fraction of the main radius, rotated a half-step
     so the two rings interleave; never tighter than 1″ off centre so
     the central-dowel crosshair stays clear */
  function innerPositionsFor(plan, supporting, scale) {
    var P = premium();
    var factor = (P && P.rules.innerRingRadiusFactor) || 0.5;
    var limitIn = supporting.d / 2 - 0.5;
    var mainRIn = Math.max(0.5, Math.min(plan.above.d / 2 - CFG.rules.ringInsetIn, limitIn));
    var r = Math.max(1, mainRIn * factor) * scale;
    var pts = [];
    var n = plan.inner;
    var step = (Math.PI * 2) / n;
    for (var m = 0; m < n; m++) {
      pts.push([Math.cos(-Math.PI / 2 + m * step) * r, Math.sin(-Math.PI / 2 + m * step) * r]);
    }
    return pts;
  }

  /* ---------- shopping list ---------- */

  function shoppingList() {
    var tiers = state.tiers;
    var spec = boardSpec();
    var mats = {};
    tiers.forEach(function (t, i) {
      var p = dowelsFor(i);
      if (!p) return;
      mats[p.material] = (mats[p.material] || 0) + p.count;
      if (p.inner) mats.wooden = (mats.wooden || 0) + p.inner; // inner rings are always wooden
    });

    var lines = [];
    Object.keys(mats).forEach(function (m) {
      var label = matLabel(m);
      lines.push(mats[m] + ' ' + (mats[m] === 1 ? label.one : label.many));
    });

    var drumTxt = '1 × ' + inch(spec.baseSize) + ' ' + spec.baseShape + ' drum (' + CFG.rules.boards.drumMm + ' mm)';
    /* 2026-08-04: when the doubling is the 8″+ safety rule, a single thicker
       drum is NOT an accepted substitute — she specified two drums glued.
       The "or one 16 mm+" alternative survives only for the stiffness case. */
    if (spec.doubled) {
      drumTxt = spec.doubleMandatory
        ? '2 × ' + inch(spec.baseSize) + ' ' + spec.baseShape + ' drums (' + CFG.rules.boards.drumMm + ' mm, glue-gunned together)'
        : '2 × ' + inch(spec.baseSize) + ' ' + spec.baseShape + ' drums (' + CFG.rules.boards.drumMm + ' mm, glued), or one 16 mm+';
    }
    lines.push(drumTxt);

    /* thin boards, grouped by size + shape */
    var groups = {};
    spec.uppers.forEach(function (b) {
      var key = b.d + '|' + b.shape;
      groups[key] = (groups[key] || 0) + 1;
    });
    Object.keys(groups).sort(function (a, b) { return parseInt(b, 10) - parseInt(a, 10); }).forEach(function (key) {
      var parts = key.split('|');
      lines.push(groups[key] + ' × ' + inch(+parts[0]) + ' ' + parts[1] + ' thin board (' + CFG.rules.boards.thinMm + ' mm)');
    });

    if (tiers.length > 1) lines.push('1 sharpened central dowel, full cake height');
    lines.push('Non-slip mat for the drive');
    return lines;
  }

  /* ---------- tool 1 rendering ---------- */

  var dowelApp, dowelResults, tierList;

  function segHtml(name, options, current, label, lockedVals) {
    var h = '<div class="lstr-field"><span class="ld-field__label" id="lbl-' + name + '">' + esc(label) + '</span>' +
            '<div class="ld-chips" role="group" aria-labelledby="lbl-' + name + '">';
    options.forEach(function (o) {
      var locked = lockedVals && lockedVals.indexOf(o[0]) !== -1;
      h += '<button type="button" class="ld-chip' + (locked ? ' is-locked' : '') + '" data-seg="' + name + '" data-val="' + o[0] + '"' +
           (locked ? ' data-lock="1" aria-label="' + esc(o[1].replace(/<[^>]*>/g, '')) + ', LAYER’D Toolkit Pro feature"' : '') +
           ' aria-pressed="' + (String(current) === o[0] ? 'true' : 'false') + '">' + o[1] + (locked ? LOCK_SVG : '') + '</button>';
    });
    return h + '</div></div>';
  }

  function stepperHtml(name, valueText, label, decDisabled, incDisabled, incLocked) {
    return '<div class="lstr-field"><span class="ld-field__label" id="lbl-' + name + '">' + esc(label) + '</span>' +
      '<div class="ld-stepper" role="group" aria-labelledby="lbl-' + name + '">' +
      '<button type="button" class="ld-stepper__btn" data-step="' + name + '" data-dir="-1" aria-label="Decrease ' + esc(label) + '"' + (decDisabled ? ' disabled' : '') + '>−</button>' +
      '<span class="ld-stepper__val" data-stepval="' + name + '" aria-live="polite">' + valueText + '</span>' +
      '<button type="button" class="ld-stepper__btn' + (incLocked ? ' is-locked' : '') + '" data-step="' + name + '" data-dir="1"' +
      (incLocked ? ' data-lock="1"' : '') + ' aria-label="Increase ' + esc(label) + (incLocked ? ', LAYER’D Toolkit Pro feature' : '') + '"' +
      (incDisabled ? ' disabled' : '') + '>+</button>' +
      '</div></div>';
  }

  function renderDowelControls() {
    var P = premium();
    var h = '';
    var tierSetup = '';
    tierSetup += stepperHtml('tiercount', state.tiers.length + ' tiers', 'Number of tiers',
                     state.tiers.length <= 2,
                     P ? state.tiers.length >= P.maxTiers : false,
                     !P && state.tiers.length >= maxTiers());
    if (!P) {
      tierSetup += '<p class="lstr-locknote">' + LOCK_SVG + ' 3–6 tiers, tall and double-barrel builds live in LAYER’D Toolkit Pro.</p>';
    }
    if (sharedNotice) {
      tierSetup += '<div class="ld-callout ld-callout--caution">' + esc(sharedNotice) + '</div>';
    }
    tierSetup += '<div id="lstr-tierlist"></div>';

    /* r54 (Mariya): the Covering and Fresh-florals/heavy-décor questions are
       retired. Covering changed no dowel/board/shopping math (it only fed the
       transport check, now also dropped); heavy décor only nudged a premium
       material and is added at the venue anyway. The calculator opens straight
       on the tiers. */
    /* 2026-09-11 (Mariya): the centre dowel was stated THREE times (this
       controls pill, an info-note in the plan, and the dowel-count note).
       Said once now, in the plan. The controls pill is dropped. */
    var options = '';

    if (structureBooking) {
      /* 6a — scoped to a client file: the file supplies the tiers, so the
         setup collapses to the mock's compact panel; the per-tier controls
         stay one tap away, nothing deleted. */
      /* r100 (Mariya, 2026-08-25): "our revised top box with the visual
         rendering disappeared … when I started a new client file". It never
         rendered here — the r97 diagram was built into the unscoped branch
         only, so attaching a file dropped straight back to the old form.
         A file-scoped cake is exactly the one worth drawing: same preview,
         same tap-a-tier-to-edit (it opens the Adjust fold below). */
      h += '<div class="lstr-jm__preview" id="lstr-jm-preview"></div>';
      /* calm-minimal (2026-09-10, Mariya): Adjust sits directly under the
         diagram/summary and BEFORE the Centre dowel row (was after it), and
         its summary is styled to match the section heads below — uniform. */
      h += '<details class="lstr-adjust"' + (adjustOpen ? ' open' : '') + '><summary>Adjust tiers &amp; cake details</summary>' + tierSetup + '</details>';
      h += options;
      /* r184 (2026-08-29, Mariya: "pressing build a dowel plan feels a bit
         useless because all it does is move you down to the dowel plan - it
         doesn't actually do anything"). She is right, and the honest fix is
         not to give it a job: the plan is computed LIVE from the tiers above
         it, so there is nothing left to build, and the page's real action -
         "Confirm structure for <name>" - already sits with the plan it
         confirms. Demoted from a full-width primary button to a quiet jump
         link, which is what it always was. Say the word and it goes
         entirely; it is kept only because this page is long on a phone. */
      h += '<button type="button" class="lstr-buildjump" data-buildplan="1">See the dowel plan ↓</button>';
    } else {
      /* r97 (Mariya): the "JUST THE MATH · Attach a client" mode strip is
         retired suite-wide — the client chip above the page owns the
         scope statement and the attach door. The card opens straight on
         the diagram. */
      h += '<div class="lstr-jm__preview" id="lstr-jm-preview"></div>';
      h += '<div class="ld-field__label" style="margin-top:12px">TIERS</div>';
      h += stepperHtml('tiercount', state.tiers.length + ' tiers', 'Number of tiers',
                       state.tiers.length <= 2,
                       P ? state.tiers.length >= P.maxTiers : false,
                       !P && state.tiers.length >= maxTiers());
      if (!P) {
        h += '<p class="lstr-locknote">' + LOCK_SVG + ' 3–6 tiers, tall and double-barrel builds live in LAYER’D Toolkit Pro.</p>';
      }
      if (sharedNotice) h += '<div class="ld-callout ld-callout--caution">' + esc(sharedNotice) + '</div>';
      /* r97: the collapsed per-tier rows retired — the diagram above IS
         the tier list (its bars carry data-jmedit). Only the tier being
         edited renders here; no tier open, nothing at all. */
      h += '<div class="lstr-jm__rows">';
      if (jmOpen != null && state.tiers[jmOpen]) {
        var jmT = jmOpen;
        var pos = jmT === 0 ? 'base' : (jmT === state.tiers.length - 1 ? 'top' : '');
        if (state.tiers[jmT].faux) pos = (pos ? pos + ' · faux' : 'faux');
        h += '<div class="lstr-jm__open"><div class="lstr-jm__openhead">' +
             '<span class="lstr-jm__idx">Tier ' + (jmT + 1) + (pos ? ' <small>· ' + pos + '</small>' : '') + '</span>' +
             '<button type="button" class="lstr-jm__done" data-jmdone="1">Done</button></div>' +
             tierCardHtml(jmT, true) + '</div>';
      } else {
        h += '<p class="lstr-jm__hint">Tap a tier on the diagram to edit its size, height and shape.</p>';
      }
      h += '</div>';
      h += '<hr class="learn-rule" style="margin:1.25rem 0">';
      h += options;
    }
    dowelApp.innerHTML = h;
    /* every stepper tap re-renders these controls — remember whether the
       tier fold was open so it doesn't snap shut mid-edit */
    var fold = dowelApp.querySelector('.lstr-adjust');
    if (fold) fold.addEventListener('toggle', function () { adjustOpen = fold.open; });
    tierList = document.getElementById('lstr-tierlist');
    if (tierList) renderTierCards();
    updateJmPreview();
  }
  var adjustOpen = false;   /* the 6a tier-fold's remembered state */
  var jmOpen = null;        /* 7b — which tier is open in the just-math rows */

  /* r97 (Mariya's diagram mock, 2026-08-24): the preview IS the plan now.
     Serif cake statement over a gold rule; then a REAL diagram — one
     bar per tier, top-to-base, width from diameter, each bar carrying
     its own dowel spec from the SAME dowelsFor() rules as ever, the
     diameter in a right-aligned gutter, TOP/BASE markers, the board
     drawn under the base with its true size — and the ink stat strip
     with the three numbers you shop from: dowels, centre, boards.
     Bars carry data-jmedit, so tapping a tier opens its editor below
     (the old collapsed row list retired — the diagram carries it). */
  function updateJmPreview() {
    var mount = document.getElementById('lstr-jm-preview');
    if (!mount) return;
    var tiers = state.tiers;
    var total = 0;
    tiers.forEach(function (t, i) { var p = dowelsFor(i); if (p) total += p.count + (p.inner || 0); });
    var centre = tiers.length > 1 ? 1 : 0;
    var spec = boardSpec();
    var boards = (spec.doubled ? 2 : 1) + spec.uppers.length;
    var shapes = {}; tiers.forEach(function (t) { shapes[t.shape] = 1; });
    var shapeTxt = Object.keys(shapes).length === 1 ? Object.keys(shapes)[0] : 'mixed-shape';
    var refD = Math.max(spec.baseSize, 4);
    tiers.forEach(function (t) { if (t.d > refD) refD = t.d; });

    /* r54 (Mariya): centred, Title Case - "3-Tier Round Cake". */
    var shapeCap = shapeTxt === 'mixed-shape' ? 'Mixed' : shapeTxt.charAt(0).toUpperCase() + shapeTxt.slice(1);
    var h = '<div class="lstr-diag__title">' + tiers.length + '-Tier ' + esc(shapeCap) + ' Cake</div>';
    h += '<div class="lstr-diag" role="group" aria-label="Your tiers with their dowel plan">';
    for (var i = tiers.length - 1; i >= 0; i--) {
      var t = tiers[i];
      var p = dowelsFor(i);
      var lbl;
      if (p) {
        /* strip only a standalone trailing word — hyphenated material
           names keep it (the word is part of the name there) */
        lbl = p.count + ' ' + matLabel(p.material).many.replace(/\s+dowels?$/i, '') +
          (p.inner ? ' + ' + p.inner + ' inner' : '');
      } else if (t.faux) {
        lbl = 'faux, no dowels';
      } else if (i === tiers.length - 1) {
        lbl = tiers.length > 1 ? 'centre only' : 'no dowels';
      } else {
        lbl = 'no dowels, ' + noDowelReason(i);
      }
      var role = i === tiers.length - 1 ? 'top' : (i === 0 ? 'base' : '');
      var w = Math.round(t.d / refD * 100);
      h += '<button type="button" class="lstr-diag__row' + (jmOpen === i ? ' is-active' : '') + '" data-jmedit="' + i + '"' +
        ' aria-label="Edit tier ' + (i + 1) + ', ' + inch(t.d) + ' ' + esc(t.shape) + ', ' + esc(lbl) + '">' +
        '<span class="lstr-diag__d">' + inch(t.d) + '</span>' +
        '<span class="lstr-diag__mid"><span class="lstr-diag__bar" style="width:' + w + '%">' +
        '<span class="lstr-diag__spec">' + esc(lbl) + '</span></span></span>' +
        '<span class="lstr-diag__role">' + role + '</span></button>';
    }
    h += '<div class="lstr-diag__boardrow"><span class="lstr-diag__d"></span>' +
      '<span class="lstr-diag__mid"><span class="lstr-diag__board" style="width:100%"></span></span>' +
      '<span class="lstr-diag__role"></span></div>';
    h += '<div class="lstr-diag__boardcap">' + (spec.doubled ? '2 × ' : '') + inch(spec.baseSize) + ' ' +
      esc(spec.baseShape) + ' board' + (spec.doubled ? 's, doubled' : '') + '</div>';
    h += '</div>';
    h += '<div class="lstr-diag__stats">' +
      '<span class="lstr-diag__stat"><span class="lstr-diag__num">' + total + '</span><span class="lstr-diag__lbl">dowels</span></span>' +
      '<span class="lstr-diag__stat"><span class="lstr-diag__num">' + (centre || '·') + '</span><span class="lstr-diag__lbl">centre</span></span>' +
      '<span class="lstr-diag__stat"><span class="lstr-diag__num">' + boards + '</span><span class="lstr-diag__lbl">boards</span></span>' +
      '</div>';
    mount.innerHTML = h;
  }

  /* one tier's controls — shared by the classic list and the 7b open card */
  function tierCardHtml(i, bare) {
    var P = premium();
    var t = state.tiers[i];
    var pos = i === 0 ? 'base' : (i === state.tiers.length - 1 ? 'top' : '');
    /* r43: say it here too — this is where she looks when the dowel
       plan skips a tier she expected to see. */
    if (state.tiers[i].faux) pos = (pos ? pos + ' · faux' : 'faux');
    var h = '<div class="lstr-tier' + (bare ? ' lstr-tier--bare' : '') + '" data-tier="' + i + '">';
    if (!bare) h += '<h3 class="lstr-tier__name">Tier ' + (i + 1) + (pos ? ' <small>· ' + pos + '</small>' : '') + '</h3>';
    /* the + button greys out at the tier below's width, - at the tier above's */
    var loD = (i < state.tiers.length - 1) ? Math.max(4, state.tiers[i + 1].d) : 4;
    var hiD = (i > 0) ? Math.min(16, state.tiers[i - 1].d) : 16;
    h += stepperHtml('d-' + i, inch(t.d), 'Diameter', t.d <= loD, t.d >= hiD);
    h += '<div class="lstr-fieldrow">';
    h += segHtml('tall-' + i, [['false', 'Standard · ' + inch(tallH() - 1) + ' or less'], ['true', 'Tall · ' + inch(tallH()) + '+']], t.tall, 'Height',
                 P ? null : ['true']);
    h += segHtml('shape-' + i, [['round', 'Round'], ['square', 'Square'], ['heart', 'Heart']], t.shape, 'Shape');
    h += '</div>';
    h += segHtml('cake-' + i, [['standard', 'Butter / sponge'], ['light', 'Chiffon (light)']], t.cake, 'Cake type');
    h += '</div>';
    return h;
  }

  function renderTierCards() {
    var h = '';
    state.tiers.forEach(function (_, i) { h += tierCardHtml(i, false); });
    tierList.innerHTML = h;
  }

  /* 6b — the side ELEVATION: tiers stacked to scale, gold support dowels
     under each supported tier, the plum centre dowel through the lot.
     Pure presentation of dowelsFor()'s existing counts — no new rules. */
  /* SPINE 2026-09-06: the side elevation moved VERBATIM into the shared engine
     (SC.elevation) so the Studio's Structure step draws the exact same picture,
     dowels and all. Thin delegate now — heights come from CFG.rules. */
  function buildElevation() {
    return SC.elevation(state.tiers, { rules: CFG.rules, premium: premium() });
  }

  function renderDowelResults(fromEdit) {
    var tiers = state.tiers;
    var spec = boardSpec();
    var warnings = stackWarnings();
    var P = premium();

    var h = '';

    /* the lifecycle's structure approval, made visible (2026-07-20):
       confirmed / not yet / needs-re-confirming — read FRESH from the
       store (this module's structureBooking is a load-time snapshot,
       and the size-change cascade can reset the flag underneath us) */
    if (structureBooking && window.LdCakeFile) {
      var fb = null;
      try {
        var st0 = window.LdCakeFile.readStore();
        for (var fi = 0; fi < st0.bookings.length; fi++) {
          if (st0.bookings[fi].id === structureBooking.id) { fb = st0.bookings[fi]; break; }
        }
      } catch (e0) { }
      if (fb) {
        var snm = esc((structureBooking.name || '').trim() || 'this file');
        var confirmBtn = '<button type="button" class="ld-btn ld-btn--primary lstr-confirm__btn" data-savehw="1">Confirm structure for ' + snm + '</button>';
        /* the mock's full-width band: text left, action right */
        if (fb.structureConfirmed) {
          h += '<div class="ld-callout ld-callout--note lstr-confirm lstr-confirm--ok">' +
            '<div class="lstr-confirm__txt"><span class="ld-callout__label">Structure confirmed ✓</span>' +
            'The plan below is saved to ' + snm + '’s file' +
            (fb.hardwareList && fb.hardwareList.at ? ' (' + esc(String(fb.hardwareList.at)) + ')' : '') +
            ', re-confirm any time after changes.</div> ' +
            '<a class="lstr-hwsave__back" href="' + hwPlannerUrl() + '?file=' + encodeURIComponent(structureBooking.id) + '">Back to ' + snm + '’s file →</a></div>';
        } else if (fb.hardwareList) {
          h += '<div class="ld-callout ld-callout--caution lstr-confirm">' +
            '<div class="lstr-confirm__txt"><span class="ld-callout__label">⚠ Needs re-confirming</span>' +
            'Sizes changed since this plan was confirmed, review the updated plan below, then confirm it again.</div> ' +
            confirmBtn + '</div>';
        } else {
          h += '<div class="ld-callout ld-callout--caution lstr-confirm">' +
            '<div class="lstr-confirm__txt"><span class="ld-callout__label">Structure not confirmed yet</span>' +
            'Review the plan below, then confirm it, that saves the hardware list to ' + snm + '’s file and ticks Structure off the outstanding list.</div> ' +
            confirmBtn + '</div>';
        }
      }
    }

    if (structureBooking && window.LdCakeFile && tiersDifferFromFile()) {
      h += '<div class="ld-callout lstr-tiersync">' +
        '<span class="ld-callout__label">Changed sizes?</span>' +
        'These tiers differ from ' + esc((structureBooking.name || '').trim() || 'the client') + '’s file. ' +
        '<button type="button" class="ld-btn ld-btn--primary lstr-tiersync__btn" data-savetiers="1">Update the file to these tiers</button>' +
        '</div>';
    }

    /* diagram */
    var anyInner = false, anyPro = false;
    tiers.forEach(function (t, i) {
      var p = dowelsFor(i);
      if (p && p.inner) anyInner = true;
      if (p && !SUPPORT_LABEL[p.material]) anyPro = true;
    });

    /* 6b — the elevation card, then DOWELS TO CUT as a data column.
       Counts and materials come from the SAME dowelsFor() rules as ever;
       cut lengths are the tier heights the tool already knows. */
    if (tiers.length > 1) {
      h += '<div class="lstr-elev"><h3>The build, from the side</h3>' + buildElevation();
      h += '<div class="lstr-elev__legend"><span><i class="lstr-key lstr-key--gold"></i>support dowels</span><span><i class="lstr-key lstr-key--plum"></i>centre dowel</span></div>';
      h += '<p class="lstr-elev__cap">side view, front dowels shown</p></div>';

      var totalCut = 0, cutRows = '', stackH = 0;
      tiers.forEach(function (t, i) {
        var tierH = t.tall ? tallH() : stdH();
        stackH += tierH;
        var p = dowelsFor(i);
        var role = roleLabel(i);
        if (!p) {
          cutRows += '<div class="lstr-cutrow"><span>' + inch(t.d) + ' ' + role + '</span><span class="lstr-cutrow__sub">' + noDowelReason(i) + '</span><span class="lstr-cutrow__num">centre only</span></div>';
        } else {
          totalCut += p.count + (p.inner || 0);
          var L = matLabel(p.material);
          cutRows += '<div class="lstr-cutrow"><span>' + inch(t.d) + ' ' + role + '</span><span class="lstr-cutrow__sub">supports ' + inch(p.above.d) + '</span>' +
            '<span class="lstr-cutrow__num">' + p.count + ' ' + (p.count === 1 ? L.one : L.many) + (p.inner ? ' + ' + p.inner + ' inner' : '') + ' · cut ' + inch(tierH) + '</span></div>';
        }
      });
      h += '<div class="ld-result ld-result--attention">';
      h += '<div class="lstr-cutcard__head"><span class="lstr-cutcard__label">DOWELS TO CUT</span><span class="lstr-cutcard__total">' + totalCut + ' <small>+ 1 centre</small></span></div>';
      h += cutRows;
      h += '<p class="lstr-cutcard__note">Dowel count follows the tier above it, supports sit just inside where that tier lands.</p>';
      h += '</div>';
    }

    /* 6b — EACH TIER FROM ABOVE, in the mock's card with Mariya's ORIGINAL
       detailed diagrams (2026-07-15: "keep the actual diagrams… get rid of
       the collapsible section… no full-stack — redundant with the side
       view"). Supporting tiers get the full drawing (traced footprint,
       true dowel positions, labels); the top tier keeps the mock's clean
       centre-only circle. */
    h += '<div class="lstr-abovecard">';
    h += '<div class="lstr-cutcard__label">EACH TIER FROM ABOVE</div>';
    h += '<div class="lstr-above__grid">';
    tiers.forEach(function (t, i) {
      var p = dowelsFor(i);
      var role = roleLabel(i);
      var sub, svg, cls;
      if (!p) {
        sub = tiers.length === 1 ? 'no dowels' : (t.faux ? 'faux, centre only' : 'centre only');
        svg = buildTierMini(i);
        cls = 'lstr-mini--detail';   /* same 220 canvas + sizing as siblings */
      } else {
        var L = matLabel(p.material);
        sub = p.count + ' ' + (p.count === 1 ? L.one : L.many) + (p.inner ? ' + ' + p.inner + ' inner' : '');
        svg = buildTierDiagram(i);
        cls = 'lstr-mini--detail';
      }
      h += '<figure class="lstr-mini ' + cls + '">' + svg +
           '<figcaption><span class="lstr-mini__name">' + inch(t.d) + ' ' + role + '</span>' +
           '<span class="lstr-mini__sub">' + sub + '</span></figcaption></figure>';
    });
    h += '</div>';
    h += '<p class="lstr-cutcard__note">Dowels per tier = the width of the tier resting on it, spaced evenly just inside where that tier sits. The dashed line is the footprint you trace from the board above.</p>';
    h += '</div>';

    /* per-tier plan */
    var whyShown = {};
    /* redesign r3 (her mockup): panels become eyebrow + rows, and every
       evergreen paragraph moves behind a "?" - same words, off the page
       until asked for. Same pattern as Batch Math's notes. */
    function infoNote(label, body, aria) {
      return '<p class="lstr-infowrap">' +
        '<span class="lstr-info__lbl">' + label + '</span>' +
        '<button type="button" class="lstr-info" aria-expanded="false">' +
          '<span aria-hidden="true">?</span>' +
          '<span class="learn-visually-hidden">' + (aria || 'More about this') + '</span>' +
        '</button>' +
        '<span class="lstr-info__pop" role="note">' + body + '</span>' +
      '</p>';
    }

    h += '<div class="learn-panel lstr-supports"><p class="lstr-eyebrow">Supports, tier by tier</p><ul class="lstr-plan lstr-plan--rows">';
    tiers.forEach(function (t, i) {
      var p = dowelsFor(i);
      var name = '<span class="lstr-srow__name">Tier ' + (i + 1) + ' · ' + inch(t.d) + ' ' + t.shape + (t.tall ? ', tall' : '') + '</span>';
      if (!p) {
        h += '<li class="lstr-srow">' + name + '<span class="lstr-srow__spec">' + (tiers.length === 1
          ? 'a single tier stands on its drum, no supports and no centre dowel'
          : 'top tier, no supports needed') + '</span></li>';
      } else {
        var label = matLabel(p.material);
        var where;
        if (p.patternShape === 'square') {
          where = p.count <= 4 ? 'in the corners of the footprint above'
                : p.count <= 8 ? 'at the corners and side midpoints of the footprint above'
                               : 'at the corners and side midpoints of the footprint above, the rest on an inner ring';
        } else {
          where = 'ring ' + (CFG.rules.ringInsetIn === 0.5 ? '½' : CFG.rules.ringInsetIn) + '″ inside the ' + inch(p.above.d) + ' footprint';
        }
        var why = '';
        if (!whyShown[p.material] && P && P.copy && P.copy.matWhy && P.copy.matWhy[p.material]) {
          why = P.copy.matWhy[p.material];
          whyShown[p.material] = true;
        }
        var innerTxt = '';
        if (p.inner && P && P.copy && P.copy.innerPlan) {
          var tplTxt = whyShown.innerRing ? (P.copy.innerPlanShort || P.copy.innerPlan) : P.copy.innerPlan;
          innerTxt = tplTxt.replace('{n}', p.inner);
          whyShown.innerRing = true;
        }
        /* the material "why" and the inner-ring note are knowledge, but
           evergreen - they ride the row's own "?" instead of the page. */
        var extra = (why || '') + (innerTxt || '');
        h += '<li class="lstr-srow">' + name +
             '<span class="lstr-srow__spec">' + p.count + ' × ' + (p.count === 1 ? label.one : label.many) +
             ' · ' + where + '</span>' +
             (extra ? infoNote('', extra, 'Why this material') : '') + '</li>';
      }
    });
    h += '</ul>';
    if (anyPro && P && P.copy && P.copy.cutterTip) {
      h += '<div class="ld-callout ld-callout--note">' + esc(P.copy.cutterTip) + '</div>';
    }
    warnings.forEach(function (w) { h += '<div class="ld-callout ld-callout--caution">' + esc(w) + '</div>'; });
    /* §2.2.2 — heart tiers: support counts use the tier's bounding round
       (the widest round that contains the heart), so the count is honest;
       placement is the judgement call the diagram can't make for you. */
    if (tiers.some(function (t) { return t.shape === 'heart'; })) {
      h += '<div class="ld-callout ld-callout--caution">Heart tier, the dowel count is worked from its bounding round (the widest round the heart fits inside), so it’s never under-supported. Set the ring <em>inside</em> the two lobes and the point rather than on the traced round edge, so no dowel lands in the thin cake near the point.</div>';
    }
    /* 6b — the stacking-risk card (the same structured gold card the
       Planner uses; method advice, no numbers) */
    if (tiers.length > 1) {
      h += '<div class="ld-callout ld-callout--caution"><div class="ld-callout__label">BEFORE YOU STACK</div>' +
           '<div class="lstr-goldcard__body">Chill each tier firm before dowelling, a soft buttercream tier will lean under the one above. Stack on the board it travels on, never assemble on site.</div></div>';
    }
    h += '</div>';

    /* stacking & delivery plan for big builds (premium copy only) */
    if (P && P.rules.stackAtVenueFromTiers && tiers.length >= P.rules.stackAtVenueFromTiers && P.copy && P.copy.venueStacking) {
      h += '<div class="learn-panel"><h3>Stacking plan</h3>';
      h += '<p style="margin:0">' + esc(P.copy.venueStacking) + '</p>';
      if (P.copy.venueFuture) h += '<p style="margin:0.6rem 0 0;font-size:0.92rem;font-style:italic">' + esc(P.copy.venueFuture) + '</p>';
      h += '</div>';
    }

    /* central dowel — always for every STACKED cake; a single tier has
       nothing to pin (Mariya, 2026-07-21) */
    if (tiers.length === 1) {
      h += '<div class="lstr-centreline">' + infoNote(
        '<strong>Central dowel</strong>, not needed on a single tier',
        'Only stacked cakes get the central dowel, with one tier there is nothing to pin together. No dowels at all on this cake.',
        'About the central dowel') + '</div>';
    } else {
      h += '<div class="lstr-centreline">' + infoNote(
        '<strong>Central dowel</strong>, always, through every tier',
        'A single sharpened dowel through all tiers is what stops them shifting sideways as a unit. ' +
        'Sharpen one end, drive it down through the centre of every tier and board after stacking, and trim flush. ' +
        'It travels through the centre holes you cut in each board <em>before</em> the tiers were built, that one prep step is what makes this moment easy. ' +
        'Forgot the holes? <a href="/pages/cake-er#structure-central-dowel">Stuck halfway is a Cake ER case</a>, and the full stacking technique is taught inside the Academy.',
        'About the central dowel') + '</div>';
    }

    /* boards */
    h += '<div class="learn-panel lstr-boards">';
    h += infoNote('<span class="lstr-eyebrow">Boards</span>',
      'Two rules for every board between tiers: it must be genuinely rigid, a flimsy board flexes on its dowel ring and lets the tier above dip in the middle, and it gets a centre hole cut <em>before</em> any cake is built on it, so the central dowel can pass straight through at stacking time.',
      'The two board rules');
    h += '<ul class="lstr-plan lstr-plan--rows">';
    /* 2026-08-04: the doubled drum names its OWN reason. An 8″+ base is
       doubled because the sides crack when the cake is moved (Mariya's
       bench rule); a 4-tier build is doubled for stiffness. Two different
       failures, so they must not share one sentence. */
    var drumWhy = spec.doubleMandatory
      ? 's × 2 (' + CFG.rules.boards.drumMm + ' mm each, glue-gunned together), an ' + inch(CFG.rules.boards.doubleDrumFromBaseIn) + '+ base cracks at the sides without it'
      : 's × 2 (' + CFG.rules.boards.drumMm + ' mm each, glued), ' + tiers.length + ' tiers need the stiffness';
    h += '<li class="lstr-srow"><span class="lstr-srow__name">Base</span><span class="lstr-srow__spec">' + inch(spec.baseSize) + ' ' + spec.baseShape + ' drum' +
         (spec.doubled ? drumWhy : ' (' + CFG.rules.boards.drumMm + ' mm)') +
         ', ' + inch(tiers[0].d) + ' tier + ' + spec.margin + '″ for the covering, a piped border and somewhere to hold' + '</span></li>';
    spec.uppers.forEach(function (b, i) {
      h += '<li class="lstr-srow"><span class="lstr-srow__name">Tier ' + (i + 2) + '</span><span class="lstr-srow__spec">' + inch(b.d) + ' ' + b.shape + ' thin board (' + CFG.rules.boards.thinMm + ' mm), exactly tier size, disappears into the covering</span></li>';
    });
    h += '</ul></div>';

    dowelResults.innerHTML = h;

    /* r54 (Mariya): the shopping list is now its OWN collapsible section,
       rendered into #lstr-shopping-body, after the plan (which holds supports
       and boards). No inner <h3> - the section header names it. */
    var list = shoppingList();
    var shopH = '<div class="learn-panel lstr-shoppanel"><ul class="lstr-shop">';
    list.forEach(function (l) { shopH += '<li>' + esc(l) + '</li>'; });
    shopH += '</ul><div class="lstr-copy"><button type="button" class="lstr-copy__door" data-copy="shop">Copy list →</button><span class="lstr-copy__done" aria-live="polite"></span></div>';
    if (structureBooking) {
      shopH += '<div class="lstr-hwsave"><button type="button" class="ld-btn ld-btn--primary" data-savehw="1">Save hardware to ' + esc(structureBooking.name || 'this file') + '</button><div class="lstr-hwsave__done" aria-live="polite" hidden></div></div>';
    }
    shopH += '</div>';
    var shopBody = document.getElementById('lstr-shopping-body');
    if (shopBody) shopBody.innerHTML = shopH;

    /* landing handoff (2026-07-21): balance the plan into two columns at
       desktop — diagrams left, plan panels right. Pure re-parenting; single
       column below 900px via CSS. Shopping is no longer part of the plan, so
       it is not routed here. */
    (function twoCol() {
      if (dowelResults.querySelector('.lstr-cols')) return;
      /* a single tier has no elevation or cut card — the columns would sit
         lopsided (one short card left, panels right), so it stays a clean
         single-column stack */
      if (state.tiers.length < 2) return;
      var left = [], right = [];
      Array.prototype.slice.call(dowelResults.children).forEach(function (n) {
        if (n.classList.contains('lstr-elev') || n.classList.contains('lstr-abovecard') ||
            (n.classList.contains('ld-result') && n.querySelector('.lstr-cutcard__head'))) left.push(n);
        else if (n.classList.contains('learn-panel')) right.push(n);
      });
      if (!left.length || !right.length) return;
      var cols = document.createElement('div');
      cols.className = 'lstr-cols';
      var cl = document.createElement('div'); cl.className = 'lstr-col';
      var cr = document.createElement('div'); cr.className = 'lstr-col';
      dowelResults.insertBefore(cols, left[0]);
      left.forEach(function (n) { cl.appendChild(n); });
      right.forEach(function (n) { cr.appendChild(n); });
      cols.appendChild(cl); cols.appendChild(cr);
    })();
    /* Toolkit Fix 02: the scratch slot is written on USER EDITS only — the
       old unconditional call meant merely OPENING this page rewrote the
       slot (h bucketed to tall/standard), poisoning what other surfaces
       later read. Load + unit-toggle re-renders never write. */
    if (fromEdit) saveSharedTiers();
    updateCakeChip();
    updateJmPreview();   /* the 7a strip's live preview + running count */
    refreshTabValues();  /* r54: the section heads carry the live summary */
  }

  /* ---------- locked-control nudge ---------- */
  /* every viewport move routes through the ONE shared utility
     (nav rule 2026-07-20); absent = no scroll, never a local fallback */
  function ldNav(target, opts) {
    var C2 = window.LAYERD && window.LAYERD.components;
    return !!(C2 && C2.navigateToSection && C2.navigateToSection(target, opts));
  }


  function lockNudge() {
    var panel = document.querySelector('.lh-locked[data-tool="structure"]');
    if (!panel) return;
    ldNav(panel, { block: 'center' });
    panel.classList.add('is-nudged');
    setTimeout(function () { panel.classList.remove('is-nudged'); }, 1600);
  }

  /* ---------- tool 1 events ---------- */

  function onDowelClick(e) {
    var btn = e.target.closest('button');
    if (!btn) return;

    if (btn.dataset.lock) { lockNudge(); return; }
    if (btn.dataset.copy === 'shop') { copyShoppingList(btn); return; }
    if (btn.dataset.savehw) { doSaveHardware(btn); return; }
    if (btn.dataset.savetiers) {
      var res = writeTiersToFile();
      if (!res) { btn.textContent = 'Couldn’t save, please try again'; return; }
      hwGa('tiers_saved');
      /* re-render: the offer disappears (file now matches) and the chip +
         pipeline bar refresh through the cakefile event writeCake fired */
      renderDowelResults();
    refreshTabValues();
      return;
    }
    if (btn.dataset.buildplan) {
      /* the plan is already computed live — the CTA carries you to it */
      if (dowelResults) ldNav(dowelResults);
      return;
    }
    /* 7a/7b — the just-math rows */
    if (btn.dataset.jmedit != null) {
      jmOpen = parseInt(btn.dataset.jmedit, 10);
      /* r100: in file-scoped mode the per-tier editors live inside the
         Adjust fold — tapping a tier on the diagram opens it there */
      if (structureBooking) adjustOpen = true;
      renderDowelControls();
      if (structureBooking) {
        var fold2 = dowelApp.querySelector('.lstr-adjust');
        if (fold2) ldNav(fold2);
      }
      return;
    }
    if (btn.dataset.jmdone) { jmOpen = null; renderDowelControls(); return; }
    if (btn.dataset.jmattach) {
      /* r5: the picker is retired — carry them to the shared bar and open
         its file list, which is where attaching happens now. */
      var bar = document.querySelector('#lstr-cakechip .ld-cakechip');
      var attach = bar && bar.querySelector('.ld-cakechip__change');
      if (bar && attach) {
        ldNav(bar, { block: 'center' });
        bar.classList.add('is-nudged');
        setTimeout(function () { bar.classList.remove('is-nudged'); }, 1600);
        setTimeout(function () { attach.click(); }, 60);
      } else {
        var flag = document.querySelector('.learn-subnav__tab--flagship');
        window.location.href = (flag && flag.getAttribute('href')) || '/pages/planner';
      }
      return;
    }

    if (btn.dataset.step) {
      var dir = parseInt(btn.dataset.dir, 10);
      var name = btn.dataset.step;
      if (name === 'tiercount') {
        var n = clamp(state.tiers.length + dir, 2, maxTiers());
        setTierCount(n);
        renderDowelControls();
      } else if (name.indexOf('d-') === 0) {
        var i = parseInt(name.slice(2), 10);
        /* UX 2026-09-08: the stack must taper — a tier can't be wider than the
           tier below it (nor narrower than the tier above), or it overhangs and
           the dowel plan is nonsense. Tiers are stored base-first (index 0 =
           base), so tier i's ceiling is the tier below (i-1) and its floor is
           the tier above (i+1), inside the global 4-16" range. */
        var loD = (i < state.tiers.length - 1) ? Math.max(4, state.tiers[i + 1].d) : 4;
        var hiD = (i > 0) ? Math.min(16, state.tiers[i - 1].d) : 16;
        state.tiers[i].d = clamp(state.tiers[i].d + dir, loD, hiD);
        var val = dowelApp.querySelector('[data-stepval="' + name + '"]');
        if (val) val.textContent = inch(state.tiers[i].d);
        syncStepperButtons(name, state.tiers[i].d, loD, hiD);
      }
      renderDowelResults(true);
      return;
    }

    if (btn.dataset.seg) {
      var seg = btn.dataset.seg, v = btn.dataset.val;
      {
        var parts = seg.split('-');
        var idx = parseInt(parts[1], 10);
        if (parts[0] === 'tall') state.tiers[idx].tall = v === 'true';
        if (parts[0] === 'shape') state.tiers[idx].shape = v;
        if (parts[0] === 'cake') state.tiers[idx].cake = v;
      }
      /* update pressed states in this group only */
      dowelApp.querySelectorAll('[data-seg="' + seg + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      renderDowelResults(true);
    }
  }

  function syncStepperButtons(name, val, lo, hi) {
    var btns = dowelApp.querySelectorAll('[data-step="' + name + '"]');
    btns.forEach(function (b) {
      b.disabled = (b.dataset.dir === '-1' && val <= lo) || (b.dataset.dir === '1' && val >= hi);
    });
  }

  function setTierCount(n) {
    var cur = state.tiers;
    if (n > cur.length) {
      while (cur.length < n) {
        var top = cur[cur.length - 1];
        cur.push({ d: clamp(top.d - 2, 4, 16), tall: false, shape: top.shape, cake: top.cake });
      }
    } else {
      cur.length = n;
    }
  }

  function doSaveHardware(btn) {
    var wrap = btn.closest('.lstr-hwsave');
    var done = wrap && wrap.querySelector('.lstr-hwsave__done');
    var res = saveHardwareToBooking();
    if (!res) { btn.textContent = 'Couldn’t save, please try again'; return; }
    hwGa('hardware_saved');
    /* flip the top banner to Confirmed ✓ (re-render is edit-free — no
       scratch writes on a non-edit pass) */
    renderDowelResults();
    refreshTabValues();
    btn = dowelResults.querySelector('.lstr-hwsave [data-savehw]') || btn;
    wrap = btn.closest('.lstr-hwsave');
    done = wrap && wrap.querySelector('.lstr-hwsave__done');
    btn.hidden = true;
    if (done) {
      var name = (structureBooking.name || '').trim() || 'this file';
      done.innerHTML = '';
      var ok = document.createElement('span');
      ok.className = 'lstr-hwsave__ok';
      ok.textContent = 'Saved to ' + name + ' ✓';
      var a = document.createElement('a');
      a.className = 'lstr-hwsave__back';
      a.href = hwPlannerUrl() + '?file=' + encodeURIComponent(structureBooking.id);
      a.textContent = 'Back to ' + name + '’s file →';
      /* round nineteen (Mariya): the per-tool Next link is retired — the
         STICKY pipeline bar's Next pill is the one next-step control */
      done.appendChild(ok);
      done.appendChild(a);
      done.hidden = false;
    }
  }

  function copyShoppingList(btn) {
    var tiers = state.tiers;
    var sizes = tiers.map(function (t) { return inch(t.d); }).join(' / ');
    var text = 'LAYER’D structure list, ' + tiers.length + '-tier cake (' + sizes + ')\n';
    shoppingList().forEach(function (l) { text += '• ' + l + '\n'; });
    text += 'Worked out at ' + location.href.split('#')[0];
    var done = btn.parentNode.querySelector('.lstr-copy__done');
    function ok() { if (done) { done.textContent = 'Copied ✓'; setTimeout(function () { done.textContent = ''; }, 2500); } }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok, function () { fallbackCopy(text); ok(); });
    } else { fallbackCopy(text); ok(); }
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (err) { /* nothing more we can do */ }
    document.body.removeChild(ta);
  }

  /* ==========================================================
     TOOL 2 — transport risk check (fully free)
     ========================================================== */

  function assessTransport() {
    var t = tstate, T = CFG.transport;
    var pts = 0;
    var hard = t.temp >= T.hardNoAcTempC && !t.ac && t.stacked;

    /* r101 (Transport redesign): the SAME rules, with each factor's own
       cost kept as it is added, so every input can say what it just did to
       the answer. Nothing new is scored here — `by` only records where the
       existing points came from. */
    var by = { drive: 0, temp: 0, ac: 0, travel: 0, road: 0 };
    if (!t.ac) {
      if (t.temp >= T.warmC) { pts += 2; by.ac += 1; by.temp += 1; }
    } else {
      if (t.temp >= T.hotC) { pts += 1; by.temp += 1; }
    }
    if (t.minutes >= T.longDriveMin) { pts += 1; by.drive += 1; }
    if (t.minutes >= T.veryLongDriveMin) { pts += 1; by.drive += 1; }
    if (t.stacked) { pts += 1; by.travel += 1; }
    if (t.road === 'rural') { pts += 1; by.road += 1; }
    if (t.road === 'city' && t.minutes >= T.longDriveMin) { pts += 1; by.road += 1; }

    var level = hard || pts >= T.highFrom ? 'high' : (pts >= T.cautionFrom ? 'caution' : 'low');
    /* the hard rule is its own band on the new scale — "don't drive it" */
    return { level: level, hard: hard, pts: pts, by: by, band: hard ? 3 : (level === 'high' ? 2 : (level === 'caution' ? 1 : 0)) };
  }

  function transportMitigations(v) {
    var t = tstate, T = CFG.transport;
    var m = [];

    if (v.hard) {
      m.push('Box the tiers separately, transport them cold, and stack at the venue. Above ' + T.hardNoAcTempC + ' °C (' + degF(T.hardNoAcTempC) + ' °F) with no AC, a stacked cake is softening the whole drive, this is the one rule not to bend.');
    }
    m.push('Chill the cake solid before loading, at least ' + T.chillHoursMin + ' hours in the fridge, ideally overnight. A cold cake is structural; a room-temperature one is upholstery.');
    m.push('Flat surface only: the footwell or the flat trunk / hatch floor, on a non-slip mat. Never a car seat and never a lap, seats slope, laps flinch.');
    if (t.temp >= T.warmC) {
      m.push(t.ac
        ? 'Pre-cool the car hard before the cake gets in, and keep the AC at its coldest, aim the vents along the cake, not at one spot on it.'
        : 'No AC on a ' + t.temp + ' °C (' + degF(t.temp) + ' °F) day: drive at the coolest hour you can, shade the box from direct sun, and keep window airflow moving.');
    }
    if (t.temp <= 0) {
      m.push('Below freezing, the risk flips: pre-warm the car to mild (not hot), a rock-frozen cake can crack its covering when it lands somewhere warm.');
    }
    if (v.level !== 'low' && t.stacked) {
      m.push('Reconsider boxing the top tier(s) separately, ten minutes of stacking at the venue removes most of the risk you’re carrying.');
    }
    if (t.road === 'rural') {
      m.push('Rural roads: it’s the potholes and washboard gravel that shear tiers sideways. Slow right down for the rough stretches, arrival time is not the goal.');
    }
    if (t.road === 'city') {
      m.push('City stop-and-go: brake like there’s a full glass of water on the dash. Leave double the following distance so no light catches you by surprise.');
    }
    if (t.minutes >= T.longDriveMin) {
      m.push('On a ' + t.minutes + '-minute drive, plan zero stops. If you must stop, park in shade, engine and AC running.');
    }
    m.push('On arrival, expect condensation as the cold cake meets warm air, it’s normal. Don’t touch or wipe it; let it evaporate. <a href="/pages/cake-er#delivery-fridge-condensation">Cake ER: condensation, handled</a>.');
    return m;
  }

  var VERDICT_COPY = {
    low: { title: 'Low risk', sub: 'This is a routine drive. Follow the loading rules below and go.' },
    caution: { title: 'Caution', sub: 'Doable, but only with the protocol below followed properly.' },
    high: { title: 'High risk', sub: 'As planned, this drive is asking for trouble. Change the plan using the steps below.' }
  };
  /* ---- r101 (her Transport design, 2026-08-25) ----
     "Show the risk while she's still deciding." The verdict is the page:
     a plum band that rewrites itself on every change, four bands wide —
     the fourth IS the engine's existing hard-no rule, not a new threshold.
     Words and colours only; every number still comes from assessTransport
     and structure-rules.json. */
  var BAND_WORD = ['Steady', 'Watch it', 'Risky', 'Don’t drive it'];
  var BAND_CALL = [
    'Well within tolerance, load it cold and go.',
    'It will hold, but the margin is thin. The precautions matter.',
    'The finish will move on this drive. Change something, or box the tiers.',
    'Not as it stands. Box the tiers separately, or move the drive.'
  ];
  /* calm-minimal (2026-09-10): the verdict card flattened onto the light
     ground, so the word colour deepened for contrast (was light tints for a
     dark panel): sage-deep, gold-deep, rose, wine. */
  var BAND_TINT = ['#5E6B53', '#7A6636', '#A15C55', '#8F3B33'];
  /* each factor says what it cost, in the design's three words */
  function costMark(n) {
    return n <= 0 ? { w: 'fine', c: '#7E8B6D' }
      : n === 1 ? { w: 'watch', c: '#A9884E' }
      : { w: 'risk', c: '#B87A72' };
  }
  /* where the marker sits: the engine's own points, mapped across the four
     bands using ITS thresholds (cautionFrom / highFrom), so the mark can
     never disagree with the word above it */
  function markerPct(v) {
    var T = CFG.transport, hi = T.highFrom, mid = T.cautionFrom;
    var top = Math.max(hi + 3, 9);              /* the practical ceiling */
    var lo, hiEdge, frac;
    if (v.hard) return 92;
    if (v.pts < mid) { lo = 0; hiEdge = mid; frac = 0; }
    else if (v.pts < hi) { lo = mid; hiEdge = hi; frac = 1; }
    else { lo = hi; hiEdge = top; frac = 2; }
    var within = hiEdge > lo ? (v.pts - lo) / (hiEdge - lo) : 0;
    /* the four segments are 20.8 / 25 / 25 / 29.2 per the design */
    var starts = [0, 20.8, 45.8, 70.8], widths = [20.8, 25, 25, 29.2];
    return Math.max(2, Math.min(98, starts[frac] + Math.min(0.96, within) * widths[frac]));
  }
  function tempC(t) { return t; }
  /* the studio's REAL marks for the hairline scales (structure-rules.json),
     never the design's illustrative ones — a mark that disagreed with the
     verdict would be the same class of bug as a vanishing component */
  function driveMarks() {
    var T = CFG.transport, max = 120;
    return [{ v: T.longDriveMin, l: T.longDriveMin }, { v: T.veryLongDriveMin, l: T.veryLongDriveMin + ' min' }]
      .map(function (m) { return { pct: Math.min(100, m.v / max * 100), label: m.l }; });
  }
  function tempMarks() {
    var T = CFG.transport, lo = -5, hi = 40;
    function pct(c) { return Math.max(0, Math.min(100, (c - lo) / (hi - lo) * 100)); }
    return [{ v: T.warmC }, { v: T.butterSoftC }, { v: T.hotC }].map(function (m) {
      return { pct: pct(m.v), label: m.v };
    });
  }
  function scaleHtml(fillPct, colour, marks, unit) {
    var h = '<div class="lstr-scale"><div class="lstr-scale__track">' +
      '<i class="lstr-scale__fill" style="width:' + Math.max(0, Math.min(100, fillPct)) + '%;background:' + colour + '"></i>';
    marks.forEach(function (m) { h += '<span class="lstr-scale__tick" style="left:' + m.pct + '%"></span>'; });
    h += '</div><div class="lstr-scale__labels">';
    marks.forEach(function (m, i) {
      h += '<span class="lstr-scale__lbl" style="left:' + m.pct + '%">' +
        esc(String(m.label) + (i === marks.length - 1 && unit ? ' ' + unit : '')) + '</span>';
    });
    return h + '</div></div>';
  }
  /* the label row above a control: name · dot · what it cost */
  function factorHead(name, cost) {
    var m = costMark(cost);
    return '<div class="lstr-fac"><span class="lstr-fac__n">' + esc(name) + '</span>' +
      '<span class="lstr-fac__dot" style="background:' + m.c + '"></span>' +
      '<span class="lstr-fac__w" style="color:' + m.c + '">' + m.w + '</span></div>';
  }

  var transportApp, transportRisk, transportInput, transportVerdict;
  var LEVEL_RANK = { low: 0, caution: 1, high: 2 };
  var LEVEL_PROSE = { low: 'low', caution: 'caution', high: 'high' };

  /* r101: the design's layout — the verdict band on top, then two thoughts
     ("The drive" / "The cake") instead of six flat label groups. Same
     controls, same engine, same ids: the steppers keep data-step and the
     segments keep data-seg, so onTransportClick is untouched. */
  function transportStepHtml(name, valueTxt, decOff, incOff) {
    return '<div class="lstr-step2">' +
      '<button type="button" class="lstr-step2__b" data-step="' + name + '" data-dir="-1"' + (decOff ? ' disabled' : '') + ' aria-label="Less">−</button>' +
      '<span class="lstr-step2__v" data-stepval="' + name + '">' + esc(valueTxt) + '</span>' +
      '<button type="button" class="lstr-step2__b" data-step="' + name + '" data-dir="1"' + (incOff ? ' disabled' : '') + ' aria-label="More">+</button>' +
      '</div>';
  }
  function transportSegHtml(seg, opts, cur) {
    return '<div class="lstr-seg2">' + opts.map(function (o) {
      var on = String(cur) === String(o[0]);
      return '<button type="button" class="lstr-seg2__b' + (on ? ' is-on' : '') + '" data-seg="' + seg + '" data-val="' + esc(o[0]) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(o[1]) + '</button>';
    }).join('') + '</div>';
  }
  function renderTransportControls() {
    var v = assessTransport(), t = tstate;
    var h = '<div class="lstr-tgroup"><div class="lstr-tgroup__h"><h3>The drive</h3><span></span></div>';

    h += '<div class="lstr-trow">' + factorHead('Drive time', v.by.drive) +
      transportStepHtml('minutes', t.minutes + ' min', t.minutes <= 5, t.minutes >= 240) +
      scaleHtml(t.minutes / 120 * 100, costMark(v.by.drive).c, driveMarks(), '') + '</div>';

    h += '<div class="lstr-trow">' + factorHead('Outdoors', v.by.temp) +
      transportStepHtml('temp', tempTxt(t.temp), t.temp <= -30, t.temp >= 40) +
      scaleHtml((t.temp + 5) / 45 * 100, costMark(v.by.temp).c, tempMarks(), '°C') + '</div>';

    h += '<div class="lstr-trow">' + factorHead('Vehicle AC', v.by.ac) +
      transportSegHtml('ac', [['true', 'AC works'], ['false', 'No AC']], t.ac) + '</div>';

    h += '<div class="lstr-trow">' + factorHead('Road', v.by.road) +
      transportSegHtml('road', [['city', 'City'], ['highway', 'Highway'], ['rural', 'Rural']], t.road) + '</div>';

    h += '</div><div class="lstr-tgroup"><div class="lstr-tgroup__h"><h3>The cake</h3><span></span></div>';

    /* r54 (Mariya): the Covering row is gone with the covering question - it
       fed a single warm-weather point that no longer exists. */
    h += '<div class="lstr-trow">' + factorHead('Travelling', v.by.travel) +
      transportSegHtml('stacked', [['true', 'Stacked'], ['false', 'Boxed separately']], t.stacked) + '</div>';

    h += '</div>';
    transportApp.innerHTML = h;
  }

  /* the answers, one compact line (verdict-stage header) */
  function transportSummary() {
    var t = tstate;
    return t.minutes + ' min · ' + t.temp + ' °C/' + degF(t.temp) + ' °F · ' +
      (t.ac ? 'AC' : 'no AC') + ' · ' + (t.stacked ? 'stacked' : 'boxed') + ' · ' + t.road;
  }

  /* the live "risk so far" chip on the input stage — same verdict engine,
     recomputed on every answer change */
  function renderTransportRisk() {
    var v = assessTransport(), t = tstate;
    /* r101: the chip becomes THE VERDICT BAND — the page's object, rewritten
       on every change. Same engine, same levels; the band adds the fourth
       word for the hard-no rule the engine already had. */
    transportRisk.className = 'lstr-verdict lstr-verdict--' + v.level;
    var fact = t.minutes + ' min ' + t.road + ' · ' + t.temp + '°C · ' +
      (t.stacked ? 'stacked' : 'boxed separately') + (t.ac ? '' : ' · no AC');
    transportRisk.innerHTML =
      '<div class="lstr-verdict__eyebrow">This drive</div>' +
      '<div class="lstr-verdict__word" style="color:' + BAND_TINT[v.band] + '">' + esc(BAND_WORD[v.band]) + '</div>' +
      '<p class="lstr-verdict__call">' + esc(BAND_CALL[v.band]) + '</p>' +
      '<div class="lstr-verdict__scale">' +
        '<div class="lstr-verdict__bar">' +
          '<span style="width:20.8%;background:#7E8B6D"></span>' +
          '<span style="width:25%;background:#A9884E"></span>' +
          '<span style="width:25%;background:#B87A72"></span>' +
          '<span style="width:29.2%;background:#8F3B33"></span>' +
        '</div>' +
        '<div class="lstr-verdict__markrow"><span class="lstr-verdict__mark" style="left:' + markerPct(v) + '%"></span></div>' +
        '<div class="lstr-verdict__ticks"><span>Steady</span><span>Watch</span><span>Risky</span><span>No</span></div>' +
      '</div>' +
      '<div class="lstr-verdict__fact">' + esc(fact) + '</div>';
    refreshTabValues();  /* r54: keep the Transport section head's value live */
  }

  /* what single, controllable change would lower the risk — computed by
     re-running the SAME assessTransport with one answer flipped. No new
     thresholds; only the actionable inputs (box the tiers, add AC). */
  function transportDrop(v) {
    if (v.level === 'low') return null;
    var t = tstate, best = v.level, lines = [];
    function levelIf(mut) {
      var saved = {}, k;
      for (k in mut) { saved[k] = t[k]; t[k] = mut[k]; }
      var lv = assessTransport().level;
      for (k in saved) t[k] = saved[k];
      return lv;
    }
    /* each line is an INDEPENDENT single change measured against the current
       verdict — never assumes another change alongside it */
    if (t.stacked) {
      var boxed = levelIf({ stacked: false });
      if (LEVEL_RANK[boxed] < LEVEL_RANK[v.level]) {
        lines.push('Boxing the tiers separately alone takes this from <b>' + LEVEL_PROSE[v.level] + '</b> to <b>' + LEVEL_PROSE[boxed] + '</b>.');
        if (LEVEL_RANK[boxed] < LEVEL_RANK[best]) best = boxed;
      }
    }
    if (!t.ac) {
      var acOnly = levelIf({ ac: true });
      if (LEVEL_RANK[acOnly] < LEVEL_RANK[v.level]) {
        lines.push('Working AC alone brings it to <b>' + LEVEL_PROSE[acOnly] + '</b>.');
        if (LEVEL_RANK[acOnly] < LEVEL_RANK[best]) best = acOnly;
      }
    }
    /* both together, only worth saying if it beats every single change */
    if (t.stacked && !t.ac) {
      var both = levelIf({ stacked: false, ac: true });
      if (LEVEL_RANK[both] < LEVEL_RANK[best]) {
        lines.push('Do both and it’s <b>' + LEVEL_PROSE[both] + '</b>.');
        best = both;
      }
    }
    if (!lines.length) return null;
    return { title: 'Drop it to ' + LEVEL_PROSE[best], body: lines.join(' ') };
  }

  /* the verdict stage — the tool's real verdict + precautions, surfaced */
  /* r101 (design 3b): "Three things to do anyway" — the SAME
     transportMitigations list, given the design's numbered treatment, with
     the lead sentence stating this drive in her own words. The count in the
     heading is the real number of precautions, never a hardcoded three. */
  function precautionLead(v) {
    var t = tstate;
    var drive = t.minutes + '-minute ' + t.road + ' drive at ' + t.temp + ' °C';
    if (v.band === 0) return 'A ' + drive + ' is steady, these are what keep it that way.';
    if (v.band === 1) return 'A ' + drive + ' holds with a thin margin, these are what hold it.';
    if (v.band === 2) return 'A ' + drive + ' will move the finish. These reduce the damage; the changes below remove it.';
    return 'A ' + drive + ', stacked with no AC, is the one rule not to bend. Box the tiers, then these apply.';
  }
  function numWordN(n) {
    return ['no', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'][n] || String(n);
  }
  function renderTransportVerdict() {
    var v = assessTransport();
    var mits = transportMitigations(v);
    var h = '<div class="lstr-trans__bar">' +
            /* r184 (2026-08-29, Mariya: "the back button called check, it's
               not very easy to find - can we make it a pill style easy to
               locate button instead"). It was 11.5px borderless text against
               a busy verdict band. Same action, now a bordered pill with a
               real tap target, and it says where it goes. */
            '<button type="button" class="lstr-trans__back" data-tedit="1">‹ Back to the check</button>' +
            '<span class="lstr-trans__summary">' + esc(transportSummary()) + '</span></div>' +
            '<div class="lstr-trans__pad">';
    h += '<h3 class="lstr-prec__h">' + esc(numWordN(mits.length) + ' thing' + (mits.length === 1 ? '' : 's') + ' to do anyway') + '</h3>';
    h += '<p class="lstr-prec__lead">' + esc(precautionLead(v)) + '</p>';
    h += '<ol class="lstr-prec">';
    mits.forEach(function (m, i) {
      /* the mitigation's first sentence is its instruction; the rest is why */
      var txt = String(m), cut = txt.search(/(?:[.:]\s)|(?:—\s)/);
      var head = cut > 12 ? txt.slice(0, cut).replace(/[:.]$/, '') : txt;
      var body = cut > 12 ? txt.slice(cut).replace(/^[.:—]\s*/, '') : '';
      h += '<li class="lstr-prec__i"><span class="lstr-prec__n">' + (i + 1) + '</span>' +
           '<div class="lstr-prec__b"><div class="lstr-prec__t">' + head + '</div>' +
           (body ? '<p class="lstr-prec__p">' + body + '</p>' : '') + '</div></li>';
    });
    h += '</ol>';
    /* "What would change this" — the engine's own single-change flips, not
       a table of invented rules */
    var drop = transportDrop(v);
    if (drop) {
      h += '<div class="lstr-change"><div class="lstr-change__h">What would change this</div>' +
           '<div class="lstr-change__body">' + drop.body + '</div></div>';
    }
    h += '</div>';
    transportVerdict.innerHTML = h;
  }

  function showTransportStage(which) {
    transportInput.hidden = which !== 'input';
    transportVerdict.hidden = which !== 'verdict';
  }

  function onTransportClick(e) {
    var btn = e.target.closest('button');
    if (!btn) return;

    if (btn.dataset.tverdict) { renderTransportVerdict(); showTransportStage('verdict'); return; }
    if (btn.dataset.tedit) { showTransportStage('input'); return; }

    /* r101: any change re-renders BOTH — the band and every factor chip.
       One input can move another factor's cost (a warmer day is what makes
       "no AC" expensive), so patching one row in place would leave the rest
       of the page lying. Focus is restored to the control just used, so a
       repeated tap on ± still works. */
    function afterChange(sel) {
      renderTransportControls();
      renderTransportRisk();
      if (!sel) return;
      var again = transportApp.querySelector(sel);
      if (again && !again.disabled) { try { again.focus({ preventScroll: true }); } catch (e) { } }
    }

    if (btn.dataset.step) {
      var dir = parseInt(btn.dataset.dir, 10);
      if (btn.dataset.step === 'minutes') tstate.minutes = clamp(tstate.minutes + dir * 5, 5, 240);
      else if (btn.dataset.step === 'temp') tstate.temp = clamp(tstate.temp + dir, -30, 40);
      afterChange('[data-step="' + btn.dataset.step + '"][data-dir="' + btn.dataset.dir + '"]');
      return;
    }

    if (btn.dataset.seg) {
      var seg = btn.dataset.seg, val = btn.dataset.val;
      if (seg === 'ac') tstate.ac = val === 'true';
      else if (seg === 'stacked') tstate.stacked = val === 'true';
      else if (seg === 'road') tstate.road = val;
      afterChange('[data-seg="' + seg + '"][data-val="' + val.replace(/"/g, '\\"') + '"]');
    }
  }

  function setTransportStepVal(name, text, decDisabled, incDisabled) {
    var val = transportApp.querySelector('[data-stepval="' + name + '"]');
    if (val) val.textContent = text;
    transportApp.querySelectorAll('[data-step="' + name + '"]').forEach(function (b) {
      b.disabled = b.dataset.dir === '-1' ? decDisabled : incDisabled;
    });
  }

  /* ==========================================================
     boot
     ========================================================== */

  /* r54 (Mariya): the results become collapsible sections in the pricing
     style - Dowel plan, Shopping list, Transport. The calculator stays open
     above them. secShell builds one section: a header button (title, a live
     summary value, a chevron) over a foldable body. */
  function secShell(id, title, bodyHtml, open) {
    return '<section class="lstr-sec' + (open ? '' : ' is-shut') + '" id="' + id + '">' +
      '<button type="button" class="lstr-sechead" aria-expanded="' + (open ? 'true' : 'false') + '">' +
        '<span class="lstr-sechead__t">' + title + '</span>' +
        '<span class="lstr-sechead__c" data-secval="' + id + '"></span>' +
        '<span class="lstr-sechead__x" aria-hidden="true">' + (open ? '⌃' : '⌄') + '</span>' +
      '</button>' +
      '<div class="lstr-secbody">' + bodyHtml + '</div>' +
    '</section>';
  }

  function init() {
    var dowelMount = document.getElementById('lstr-dowel-app');
    var transportMount = document.getElementById('lstr-transport-app');
    if (!dowelMount || !transportMount) return;

    /* Graceful degradation: missing/malformed config island means the
       written guide below the tools carries the page, no broken
       half-rendered calculator, no console errors. */
    if (!CFG || !CFG.rules || !CFG.transport || !CFG.presets) {
      var sorry = '<p class="lstr-loading">The calculator couldn’t load its settings just now. ' +
                  'Refresh the page, or scroll down: the full written method is right below.</p>';
      dowelMount.innerHTML = sorry;
      transportMount.innerHTML = sorry;
      return;
    }

    /* Landing handoff round 2 (2026-07-21): the mock stacks the page —
       full-width controls card on top, then the confirm band, then the
       results in two full-width columns. The old controls-left /
       results-right split crammed every result card into half the page. */
    /* the calculator controls stay open at the top; the plan and the
       shopping list fold underneath as two sections (r54). */
    dowelMount.innerHTML =
      '<div class="lstr-grid"><div class="lstr-controls lstr-ctlcard" id="lstr-dowel-controls"></div>' +
      '<div class="lstr-acc">' +
        secShell('lstr-sec-plan', 'Dowel plan',
          '<div class="lstr-results" id="lstr-dowel-results" aria-live="polite"></div>', true) +
        secShell('lstr-sec-shop', 'Shopping list',
          '<div id="lstr-shopping-body" aria-live="polite"></div>', false) +
      '</div></div>';
    /* r54: the transport check is the third collapsible. Its own <h2> is
       hidden (the section header names it).
       calm-minimal (2026-09-10, Mariya): the protected "most dangerous hour"
       lede used to sit as a centred interstitial BETWEEN the shop section and
       the transport section — "a little out of place". It's studio-voice copy,
       so it's kept, not cut: the node is physically MOVED into the transport
       fold as its intro (no duplicate text), and the floating line is gone. */
    var tLede = document.querySelector('#transport-tool .lstr-tool__lede');
    var tH2 = document.getElementById('transport-tool-title');
    if (tH2) tH2.hidden = true;
    transportMount.innerHTML =
      '<div class="lstr-acc">' + secShell('lstr-sec-transport', 'Transport',
        '<p class="lstr-trans__lede" id="lstr-trans-lede-slot"></p>' +
        '<div class="lstr-trans">' +
          '<div class="lstr-trans__stage lstr-controls" id="lstr-transport-input">' +
            '<div class="lstr-verdict lstr-verdict--low" id="lstr-transport-risk" aria-live="polite"></div>' +
            '<div class="lstr-trans__pad">' +
              '<div id="lstr-transport-controls"></div>' +
              '<button type="button" class="ld-btn ld-btn--primary lstr-trans__go" data-tverdict="1">Precautions for this drive →</button>' +
            '</div>' +
          '</div>' +
          '<div class="lstr-trans__stage lstr-controls" id="lstr-transport-verdict" aria-live="polite" hidden></div>' +
        '</div>', false) +
      '</div>';

    /* move the protected lede node into the fold's intro slot — same node,
       so the studio-voice sentence is preserved with no duplicate text */
    if (tLede) {
      var ledeSlot = document.getElementById('lstr-trans-lede-slot');
      if (ledeSlot && ledeSlot.parentNode) ledeSlot.parentNode.replaceChild(tLede, ledeSlot);
      tLede.className = 'lstr-tool__lede lstr-trans__lede';
    }

    dowelApp = document.getElementById('lstr-dowel-controls');
    dowelResults = document.getElementById('lstr-dowel-results');
    transportApp = document.getElementById('lstr-transport-controls');
    transportRisk = document.getElementById('lstr-transport-risk');
    transportInput = document.getElementById('lstr-transport-input');
    transportVerdict = document.getElementById('lstr-transport-verdict');

    var startN = premium() ? 3 : 2;
    state.tiers = presetFor(startN).map(function (d) {
      return { d: d, tall: false, shape: 'round', cake: 'standard' };
    });

    /* Seed the tiers (Toolkit Fix 01): when a client file is active, the
       BOOKING RECORD is the only source of truth, a cake explicitly set on
       the file loads here; a file whose cake was never set gets the honest
       empty state (§3.4) instead of preset placeholders posing as client
       data. Unscoped keeps the anonymous scratch-slot behaviour. */
    var fileEmpty = false;
    var scopeBid = structureBooking ? structureBooking.id : null;
    if (scopeBid && window.LdCakeFile) {
      var rc = window.LdCakeFile.readCake();
      if (rc.source === 'booking') {
        var mapped = mapIncomingTiers(rc.tiers);
        if (mapped.length >= 1) { state.tiers = mapped; adoptedFrom = 'planner'; }
      } else {
        fileEmpty = true;
      }
    } else if (scopeBid) {
      /* no-helper fallback: the client's saved tierSpec, preset-padded */
      var fromSpec = tiersFromBooking(structureBooking);
      if (fromSpec) { state.tiers = fromSpec; adoptedFrom = 'planner'; }
    } else {
      var raw = readSharedRaw();
      var sharedBid = (raw && raw.bookingId !== undefined) ? (raw.bookingId || null) : null;
      if (sharedBid === null) {
        var shared = loadSharedTiers();
        if (shared) { state.tiers = shared; adoptedFrom = (raw && raw.from) || null; }
      }
    }

    /* in/cm toggle above the tool; flipping it re-renders the controls
       (steppers, height chips) and the results (plan text, shopping
       list, SVG diagram labels). Transport has no pan sizes. */
  /* r3: the units toggle docks in the compact header; the old spot is the
     fallback so a not-yet-updated template still works. Position has no
     bearing on behaviour - the listeners live in unitListeners. */
  (function mountUnits() {
  /* r25 (2026-07-31, Mariya): the unit pills move OUT of the header and
     sit just under the client bar. In the header they competed with the
     tier badge for the same row and knocked it out of line on the pages
     that carry them. Position only - the listeners are unchanged. */
    var pills = unitToggle();
    var bar = document.querySelector('.ld-cakechip-row');
    if (bar && bar.parentNode) {
      pills.classList.add('ld-unitrow');
      pills.classList.add('learn-wrap');   /* r26: same wrap as the bar */
      bar.parentNode.insertBefore(pills, bar.nextSibling);
      return;
    }
    var slot = document.getElementById('lstr-units-slot');
    if (slot) slot.appendChild(pills);
    else dowelMount.insertBefore(pills, dowelMount.firstChild);
  })();
    unitListeners.push(function () { renderDowelControls(); renderDowelResults(); });

    /* r5 (2026-07-30): the standalone client <select> is retired suite-wide.
       The shared bar (#lstr-cakechip) names the file and owns the file list
       behind its "change" link, one identity control, same on every tool. */
    (function clientScope() {
      if (structureBooking) hwGa('hardware_opened');
    })();

    if (fileEmpty) {
      /* §3.4 empty state: the file has no explicitly-set cake, point at
         Serving (the pointer is global, so the link needs no param). The
         transport check below still runs; it doesn't need the tiers. */
      var enm = (structureBooking.name || '').trim() || 'this file';
      var egrid = dowelMount.querySelector('.lstr-grid') || dowelMount;
      egrid.innerHTML =
        '<div class="ld-callout ld-callout--check lstr-fileempty">' +
        '<span class="ld-callout__label">No tiers on ' + esc(enm) + '’s file yet</span>' +
        'Set the cake’s tiers first and the dowel plan builds itself, ' +
        '<a href="/pages/serving-size-calculator">size them in Serving →</a> ' +
        'or pick a suggested stack on the client file in ' +
        '<a href="/pages/planner?file=' + encodeURIComponent(structureBooking.id) + '">the Planner →</a></div>';
    } else {
      renderDowelControls();
      renderDowelResults();
    refreshTabValues();
    }
    renderTransportControls();
    renderTransportRisk();
    showTransportStage('input');

    dowelMount.addEventListener('click', onDowelClick);
    transportMount.addEventListener('click', onTransportClick);
    wireStepperHold(dowelMount);
    wireStepperHold(transportMount);
  }

  /* ---------- hold-to-repeat on the +/− steppers (2026-07-09) ----------
     Mariya's mobile review: tapping − twenty times to drop the venue
     temperature is hostile on a phone. Press-and-hold now repeats the
     step after 400 ms and accelerates; it synthesizes .click() so every
     stepper keeps its one source of logic. The trailing click browsers
     fire after a HOLD is swallowed so the value doesn't jump one extra.
     (Pairs with touch-action:manipulation in the tokens CSS, which
     stops a missed tap from double-tap-zooming the page.) */
  function wireStepperHold(mount) {
    var timer = null, held = null, repeated = false, synthetic = false;
    function stop() {
      if (timer) { clearTimeout(timer); timer = null; }
      held = null;
    }
    mount.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest('[data-step]');
      if (!btn || btn.disabled) return;
      held = btn; repeated = false;
      var delay = 400;
      function tick() {
        if (!held || !held.isConnected || held.disabled) { stop(); return; }
        repeated = true;
        synthetic = true; held.click(); synthetic = false;
        delay = Math.max(60, delay * 0.82);
        timer = setTimeout(tick, delay);
      }
      timer = setTimeout(tick, delay);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      mount.addEventListener(ev, stop);
    });
    mount.addEventListener('click', function (e) {
      if (synthetic) return;                       /* our own repeats pass through */
      if (repeated && e.target.closest('[data-step]')) {
        repeated = false;                          /* eat ONE trailing click after a hold */
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);
  }

  /* Redesign round 3 (2026-07-30): the jump bar becomes a real TAB STRIP,
     the way Batch Math's did - three destinations, each pill carrying the
     live answer underneath its label. "The method" left the bar and folds
     away at the foot of the page (her call). Injected here so the template
     needs no re-paste; without JS every section simply stays visible. */
  /* r54 (Mariya): the jump bar is retired - the three collapsible section
     headers ARE the navigation now, each carrying its live summary value. */
  var LSTR_SECS = [
    { id: 'lstr-sec-plan', kind: 'plan' },
    { id: 'lstr-sec-shop', kind: 'shop' },
    { id: 'lstr-sec-transport', kind: 'transport' }
  ];
  /* the value beside each section title - read from what the tool already
     rendered, so they can never disagree with the panels. */
  function secValueFor(kind) {
    try {
      if (kind === 'plan') {
        var n = 0;
        for (var i = 0; i < state.tiers.length; i++) {
          var p = dowelsFor(i);
          if (p) n += p.count + (p.inner || 0);
        }
        if (!n) return '';
        return state.tiers.length > 1 ? n + ' dowels + 1 centre' : String(n) + ' dowels';
      }
      if (kind === 'shop') {
        var items = shoppingList().length;
        return items ? items + (items === 1 ? ' item' : ' items') : '';
      }
      if (kind === 'transport') {
        var v = assessTransport();
        return { low: 'Straightforward', caution: 'Moderate', high: 'High risk' }[v.level] || '';
      }
    } catch (e) { return ''; }
    return '';
  }
  /* kept its old name so every existing call site updates the section heads */
  function refreshTabValues() {
    LSTR_SECS.forEach(function (s) {
      var slot = document.querySelector('[data-secval="' + s.id + '"]');
      if (slot) slot.textContent = secValueFor(s.kind);
    });
  }
  function openSec(sec) {
    if (!sec) return;
    sec.classList.remove('is-shut');
    var head = sec.querySelector('.lstr-sechead');
    if (head) {
      head.setAttribute('aria-expanded', 'true');
      var x = head.querySelector('.lstr-sechead__x');
      if (x) x.textContent = '⌃';
    }
  }
  function initJumpBar() {
    /* deep links (#lstr-sec-transport, or the legacy #transport-tool /
       #lstr-shopping) open the target section and scroll to it. */
    var hash = (location.hash || '').slice(1);
    if (hash) {
      var map = { 'transport-tool': 'lstr-sec-transport', 'lstr-shopping': 'lstr-sec-shop', 'dowel-tool': 'lstr-sec-plan' };
      var id = map[hash] || hash;
      var target = document.getElementById(id);
      if (target) setTimeout(function () {
        openSec(target);
        try { target.scrollIntoView({ block: 'start' }); } catch (e) { }
      }, 120);
    }
    refreshTabValues();
  }

  /* r54 (Mariya): the collapsible section headers - Dowel plan, Shopping
     list, Transport. Each folds on its own tap; the chevron follows. */
  document.addEventListener('click', function (ev) {
    var head = ev.target && ev.target.closest ? ev.target.closest('.lstr-sechead') : null;
    if (!head) return;
    var sec = head.closest('.lstr-sec');
    if (!sec) return;
    ev.preventDefault();
    if (sec.classList.contains('is-shut')) {
      openSec(sec);
    } else {
      sec.classList.add('is-shut');
      head.setAttribute('aria-expanded', 'false');
      var x = head.querySelector('.lstr-sechead__x');
      if (x) x.textContent = '⌄';
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initJumpBar(); });
  } else {
    init();
    initJumpBar();
  }
})();